(() => {
  // Connect accounts and replace demo catalog data before launch.
  const CONFIG = {
    contactEmail: "mavis@coolstarpoker.com",
    whatsappNumber: "+86 17706858396",
    ga4Id: "",
    searchConsoleVerification: "",
    tiktokPixelId: "",
    metaPixelId: "",
    klaviyoPublicKey: "",
    stripePublishableKey: "",
    paypalClientId: "",
    reviewProvider: "",
    creatorCodes: {}
  };
  if (window.CoolstarShopifyTheme?.settings?.whatsappNumber) CONFIG.whatsappNumber = window.CoolstarShopifyTheme.settings.whatsappNumber;
  const CART_KEY = "coolstar_cart_v1";
  const QUOTE_KEY = "coolstar_quote_list";
  const CONSENT_KEY = "coolstar_consent_v1";
  const ATTRIBUTION_KEY = "coolstar_creator_v1";
  const LANGUAGE_KEY = "coolstar_language";
  const CURRENCY_KEY = "coolstar_currency";
  const RATE_CACHE_KEY = "coolstar_fx_rates_v2";
  const currencyCodes = ["USD", "EUR", "GBP", "CNY", "JPY", "CAD", "AUD", "CHF", "INR", "KRW", "SGD", "HKD", "MXN", "BRL", "AED", "SAR", "NZD", "SEK", "NOK", "DKK", "PLN", "THB", "MYR", "IDR", "PHP", "CZK", "HUF", "ISK", "RON", "TRY", "RSD", "UAH", "RUB", "ILS", "QAR", "KWD", "BHD", "OMR", "ZAR", "EGP", "MAD", "NGN", "GHS", "KES", "XAF", "XOF", "ARS", "CLP", "COP", "PEN", "UYU", "CRC", "VND", "PKR", "BDT", "LKR", "NPR", "FJD", "ALL", "BAM", "GEL", "MDL", "JOD", "TND", "XCD", "JMD", "TWD", "KZT", "AZN", "AMD", "MKD", "DZD", "ETB", "UGX", "TZS", "BWP", "MUR", "BOB", "DOP", "TTD", "BBD", "BSD", "BZD", "PYG", "GTQ", "HNL", "NIO", "PAB", "GMD", "MZN", "XPF", "MOP"];
  const fixedUsdRates = { AED: 3.6725, SAR: 3.75, QAR: 3.64, BHD: 0.376, OMR: 0.3845, JOD: 0.709, HKD: 7.8, XCD: 2.7, PAB: 1, BSD: 1, BBD: 2, BZD: 2 };
  const fixedEurRates = { DKK: 7.46038, BAM: 1.95583, XAF: 655.957, XOF: 655.957, XPF: 119.331742 };
  const localeTags = { en: "en-US", "en-GB": "en-GB", "zh-CN": "zh-CN", "zh-TW": "zh-TW", es: "es-ES", fr: "fr-FR", de: "de-DE", it: "it-IT", pt: "pt-PT", ja: "ja-JP", ko: "ko-KR", ar: "ar", ru: "ru-RU", hi: "hi-IN", nl: "nl-NL", tr: "tr-TR", pl: "pl-PL", sv: "sv-SE", no: "nb-NO", da: "da-DK", fi: "fi-FI", el: "el-GR", cs: "cs-CZ", hu: "hu-HU", ro: "ro-RO", uk: "uk-UA", bg: "bg-BG", hr: "hr-HR", sr: "sr-RS", is: "is-IS", et: "et-EE", lv: "lv-LV", lt: "lt-LT", sk: "sk-SK", sl: "sl-SI", mt: "mt-MT", ga: "ga-IE" };
  const languageLabels = { en: "US · English", "en-GB": "UK · English", "zh-CN": "简体中文", "zh-TW": "繁體中文", es: "ES · Español", fr: "FR · Français", de: "DE · Deutsch", it: "IT · Italiano", pt: "PT · Português", ja: "日本語", ko: "한국어", ar: "العربية", ru: "Русский", hi: "हिन्दी", nl: "NL · Nederlands", tr: "TR · Türkçe", pl: "PL · Polski", sv: "SE · Svenska", no: "NO · Norsk", da: "DK · Dansk", fi: "FI · Suomi", el: "GR · Ελληνικά", cs: "CZ · Čeština", hu: "HU · Magyar", ro: "RO · Română", uk: "UA · Українська", bg: "BG · Български", hr: "HR · Hrvatski", sr: "RS · Srpski", is: "IS · Íslenska", et: "EE · Eesti", lv: "LV · Latviešu", lt: "LT · Lietuvių", sk: "SK · Slovenčina", sl: "SI · Slovenščina", mt: "MT · Malti", ga: "IE · Gaeilge" };
  const languageKeys = Object.keys(languageLabels);
  const savedLanguage = localStorage.getItem(LANGUAGE_KEY);
  const savedCurrency = localStorage.getItem(CURRENCY_KEY);
  let activeLanguage = languageKeys.includes(savedLanguage) ? savedLanguage : "en";
  let displayCurrency = currencyCodes.includes(savedCurrency) ? savedCurrency : "USD";
  let fxRates = { USD: 1 };

  if (CONFIG.searchConsoleVerification) {
    let verification = document.querySelector('meta[name="google-site-verification"]');
    if (!verification) { verification = document.createElement("meta"); verification.name = "google-site-verification"; document.head.appendChild(verification); }
    verification.content = CONFIG.searchConsoleVerification;
  }

  const readJson = (key, fallback) => {
    try { return JSON.parse(localStorage.getItem(key) || "null") ?? fallback; }
    catch { return fallback; }
  };
  const writeJson = (key, value) => localStorage.setItem(key, JSON.stringify(value));
  const escapeHtml = value => String(value ?? "").replace(/[&<>"']/g, char => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char]));
  const cachedRates = readJson(RATE_CACHE_KEY, null);
  const fxRatesFetchedAt = { ...(cachedRates?.fetchedAt || {}) };
  const fxRateDates = { ...(cachedRates?.dates || {}) };
  if (cachedRates?.rates && typeof cachedRates.rates === "object") {
    Object.entries(cachedRates.rates).forEach(([code, value]) => {
      const rate = Number(value);
      if (currencyCodes.includes(code) && Number.isFinite(rate) && rate > 0) fxRates[code] = rate;
    });
  }
  fxRates.USD = 1;
  const money = amount => window.CoolstarShopifyTheme ? new Intl.NumberFormat(localeTags[activeLanguage] || "en-US", { style: "currency", currency: window.Shopify?.currency?.active || "USD" }).format(Number(amount || 0)) : new Intl.NumberFormat(localeTags[activeLanguage] || "en-US", { style: "currency", currency: fxRates[displayCurrency] ? displayCurrency : "USD" }).format(Number(amount || 0) * (fxRates[displayCurrency] || 1));
  const interfaceCopy = {
    en: { home: "Home", products: "Products", wholesale: "Wholesale", custom: "Custom & OEM", about: "About", contact: "Contact", signIn: "Sign in", myAccount: "My account", cart: "Cart", search: "Search...", quote: "Get a quote", made: "Made for your brand", chips: "Design your own custom chips", experience: "factory experience", supplier: "Factory-direct supplier", retail: "Retail + wholesale", solutions: "Custom OEM solutions", updated: "Language updated. Shopping navigation is now in English.", currency: "Prices updated. Checkout remains in USD." },
    "zh-CN": { home: "首页", products: "全部商品", wholesale: "批发采购", custom: "定制与代工", about: "关于我们", contact: "联系我们", signIn: "登录", myAccount: "我的账户", cart: "购物车", search: "搜索商品…", quote: "获取报价", made: "为您的品牌定制", chips: "设计你的专属芯片", experience: "工厂经验", supplier: "工厂直供", retail: "零售与批发", solutions: "OEM 定制方案", updated: "语言已切换，购物导航已更新为简体中文。", currency: "价格已更新，结算仍使用美元。" },
    "zh-TW": { home: "首頁", products: "全部商品", wholesale: "批發採購", custom: "客製與代工", about: "關於我們", contact: "聯絡我們", signIn: "登入", myAccount: "我的帳戶", cart: "購物車", search: "搜尋商品…", quote: "取得報價", made: "為您的品牌打造", chips: "設計您的專屬籌碼", experience: "工廠經驗", supplier: "工廠直供", retail: "零售與批發", solutions: "OEM 客製方案", updated: "語言已切換，購物導覽已更新為繁體中文。", currency: "價格已更新，結帳仍使用美元。" },
    es: { home: "Inicio", products: "Productos", wholesale: "Mayorista", custom: "Personalización", about: "Nosotros", contact: "Contacto", signIn: "Iniciar sesión", myAccount: "Mi cuenta", cart: "Carrito", search: "Buscar…", quote: "Pedir presupuesto", made: "Hecho para tu marca", chips: "Diseña tus propias fichas personalizadas", experience: "de experiencia fabril", supplier: "Proveedor directo de fábrica", retail: "Venta minorista y mayorista", solutions: "Soluciones OEM a medida", updated: "Idioma actualizado. Navegación en español.", currency: "Precios actualizados. El pago final sigue en USD." },
    fr: { home: "Accueil", products: "Produits", wholesale: "Grossiste", custom: "Personnalisation", about: "À propos", contact: "Contact", signIn: "Connexion", myAccount: "Mon compte", cart: "Panier", search: "Rechercher…", quote: "Demander un devis", made: "Créé pour votre marque", chips: "Concevez vos jetons personnalisés", experience: "d’expérience en usine", supplier: "Fournisseur direct usine", retail: "Détail et gros", solutions: "Solutions OEM sur mesure", updated: "Langue mise à jour. Navigation en français.", currency: "Prix mis à jour. Le paiement reste en USD." },
    de: { home: "Startseite", products: "Produkte", wholesale: "Großhandel", custom: "Individuelle Fertigung", about: "Über uns", contact: "Kontakt", signIn: "Anmelden", myAccount: "Mein Konto", cart: "Warenkorb", search: "Suchen…", quote: "Angebot anfragen", made: "Für Ihre Marke gefertigt", chips: "Gestalten Sie Ihre individuellen Pokerchips", experience: "Jahre Werkerfahrung", supplier: "Direkt vom Hersteller", retail: "Einzel- und Großhandel", solutions: "Individuelle OEM-Lösungen", updated: "Sprache aktualisiert. Navigation auf Deutsch.", currency: "Preise aktualisiert. Zahlung weiterhin in USD." },
    it: { home: "Home", products: "Prodotti", wholesale: "Ingrosso", custom: "Personalizzazione", about: "Azienda", contact: "Contatti", signIn: "Accedi", myAccount: "Il mio account", cart: "Carrello", search: "Cerca…", quote: "Richiedi un preventivo", made: "Creato per il tuo brand", chips: "Progetta le tue fiches personalizzate", experience: "di esperienza produttiva", supplier: "Direttamente dalla fabbrica", retail: "Dettaglio e ingrosso", solutions: "Soluzioni OEM personalizzate", updated: "Lingua aggiornata. Navigazione in italiano.", currency: "Prezzi aggiornati. Il pagamento resta in USD." },
    pt: { home: "Início", products: "Produtos", wholesale: "Atacado", custom: "Personalização", about: "Sobre", contact: "Contato", signIn: "Entrar", myAccount: "Minha conta", cart: "Carrinho", search: "Buscar…", quote: "Pedir orçamento", made: "Feito para sua marca", chips: "Crie suas próprias fichas personalizadas", experience: "de experiência fabril", supplier: "Direto da fábrica", retail: "Varejo e atacado", solutions: "Soluções OEM personalizadas", updated: "Idioma atualizado. Navegação em português.", currency: "Preços atualizados. Pagamento segue em USD." },
    ja: { home: "ホーム", products: "商品一覧", wholesale: "卸売", custom: "カスタム・OEM", about: "会社案内", contact: "お問い合わせ", signIn: "ログイン", myAccount: "マイアカウント", cart: "カート", search: "商品を検索…", quote: "見積もりを依頼", made: "ブランドに合わせて製作", chips: "オリジナルポーカーチップをデザイン", experience: "の工場実績", supplier: "工場直送サプライヤー", retail: "小売・卸売", solutions: "カスタムOEM対応", updated: "言語を日本語に変更しました。", currency: "価格を更新しました。決済通貨はUSDです。" },
    ko: { home: "홈", products: "제품", wholesale: "도매", custom: "맞춤 제작", about: "회사 소개", contact: "문의", signIn: "로그인", myAccount: "내 계정", cart: "장바구니", search: "제품 검색…", quote: "견적 요청", made: "브랜드에 맞춘 제작", chips: "나만의 포커 칩을 디자인하세요", experience: "제조 경험", supplier: "공장 직영 공급", retail: "소매 및 도매", solutions: "맞춤 OEM 솔루션", updated: "언어가 한국어로 변경되었습니다.", currency: "가격이 업데이트되었습니다. 결제는 USD로 진행됩니다." },
    ar: { home: "الرئيسية", products: "المنتجات", wholesale: "الجملة", custom: "تصنيع حسب الطلب", about: "من نحن", contact: "اتصل بنا", signIn: "تسجيل الدخول", myAccount: "حسابي", cart: "السلة", search: "ابحث عن المنتجات…", quote: "اطلب عرض سعر", made: "مصمم لعلامتك التجارية", chips: "صمّم رقائق البوكر الخاصة بك", experience: "من الخبرة الصناعية", supplier: "مورد مباشر من المصنع", retail: "التجزئة والجملة", solutions: "حلول OEM مخصصة", updated: "تم تحديث اللغة إلى العربية.", currency: "تم تحديث الأسعار. الدفع النهائي بالدولار الأمريكي." },
    ru: { home: "Главная", products: "Товары", wholesale: "Опт", custom: "Индивидуальный заказ", about: "О компании", contact: "Контакты", signIn: "Войти", myAccount: "Мой аккаунт", cart: "Корзина", search: "Поиск товаров…", quote: "Запросить цену", made: "Для вашего бренда", chips: "Создайте собственные покерные фишки", experience: "лет опыта производства", supplier: "Поставка напрямую с фабрики", retail: "Розница и опт", solutions: "Индивидуальные OEM-решения", updated: "Язык обновлён. Навигация на русском.", currency: "Цены обновлены. Оплата остаётся в USD." },
    hi: { home: "होम", products: "उत्पाद", wholesale: "थोक", custom: "कस्टम और OEM", about: "हमारे बारे में", contact: "संपर्क", signIn: "साइन इन", myAccount: "मेरा खाता", cart: "कार्ट", search: "उत्पाद खोजें…", quote: "कीमत पूछें", made: "आपके ब्रांड के लिए", chips: "अपने कस्टम पोकर चिप्स डिज़ाइन करें", experience: "का फैक्टरी अनुभव", supplier: "सीधे फैक्टरी से आपूर्ति", retail: "रिटेल और थोक", solutions: "कस्टम OEM समाधान", updated: "भाषा अपडेट हुई। नेविगेशन हिंदी में है।", currency: "कीमतें अपडेट हुईं। भुगतान USD में होगा।" },
    nl: { home: "Home", products: "Producten", wholesale: "Groothandel", custom: "Maatwerk", about: "Over ons", contact: "Contact", signIn: "Inloggen", myAccount: "Mijn account", cart: "Winkelwagen", search: "Producten zoeken…", quote: "Offerte aanvragen", made: "Gemaakt voor uw merk", chips: "Ontwerp uw eigen pokerfiches", experience: "jaar fabriekservaring", supplier: "Rechtstreeks van de fabriek", retail: "Retail en groothandel", solutions: "Maatwerk OEM-oplossingen", updated: "Taal bijgewerkt. Navigatie in het Nederlands.", currency: "Prijzen bijgewerkt. Afrekenen blijft in USD." },
    tr: { home: "Ana sayfa", products: "Ürünler", wholesale: "Toptan", custom: "Özel üretim", about: "Hakkımızda", contact: "İletişim", signIn: "Giriş yap", myAccount: "Hesabım", cart: "Sepet", search: "Ürün ara…", quote: "Teklif alın", made: "Markanız için üretildi", chips: "Kendi özel poker fişlerinizi tasarlayın", experience: "yıllık fabrika deneyimi", supplier: "Doğrudan fabrikadan tedarik", retail: "Perakende ve toptan", solutions: "Özel OEM çözümleri", updated: "Dil güncellendi. Gezinme Türkçe.", currency: "Fiyatlar güncellendi. Ödeme USD olarak kalır." }
  };
  const t = key => interfaceCopy[activeLanguage]?.[key] || interfaceCopy[activeLanguage.split("-")[0]]?.[key] || interfaceCopy.en[key];
  const welcomeGiftCopy = { en: { button: "Welcome gift", kicker: "First order offer" }, "zh-CN": { button: "领取欢迎礼包", kicker: "新用户礼遇" }, "zh-TW": { button: "領取歡迎禮包", kicker: "新用戶禮遇" } };
  const welcomeText = key => (welcomeGiftCopy[activeLanguage] || welcomeGiftCopy[activeLanguage.split("-")[0]] || welcomeGiftCopy.en)[key] || welcomeGiftCopy.en[key];

  document.querySelectorAll("[data-year]").forEach(el => el.textContent = new Date().getFullYear());
  const trustTopline = document.querySelector(".topline");
  if (trustTopline && !trustTopline.dataset.storeTrustbar) {
    trustTopline.dataset.storeTrustbar = "true";
    trustTopline.classList.add("store-trustbar");
    const languageOptions = [
      ["en", "US · English"], ["en-GB", "UK · English"], ["es", "ES · Español"], ["fr", "FR · Français"],
      ["de", "DE · Deutsch"], ["it", "IT · Italiano"], ["pt", "PT · Português"], ["nl", "NL · Nederlands"],
      ["pl", "PL · Polski"], ["sv", "SE · Svenska"], ["no", "NO · Norsk"], ["da", "DK · Dansk"],
      ["fi", "FI · Suomi"], ["el", "GR · Ελληνικά"], ["cs", "CZ · Čeština"], ["hu", "HU · Magyar"],
      ["ro", "RO · Română"], ["bg", "BG · Български"], ["hr", "HR · Hrvatski"], ["sk", "SK · Slovenčina"],
      ["sl", "SI · Slovenščina"], ["et", "EE · Eesti"], ["lv", "LV · Latviešu"], ["lt", "LT · Lietuvių"],
      ["mt", "MT · Malti"], ["ga", "IE · Gaeilge"], ["uk", "UA · Українська"], ["sr", "RS · Srpski"],
      ["is", "IS · Íslenska"], ["tr", "TR · Türkçe"], ["zh-CN", "简体中文"],
      ["zh-TW", "繁體中文"], ["ja", "日本語"], ["ko", "한국어"], ["ar", "العربية"], ["ru", "Русский"], ["hi", "हिन्दी"]
    ];
    const currencyOptions = [
      ["USD", "USD $ · US dollar"], ["EUR", "EUR € · Euro"], ["GBP", "GBP £ · Pound"], ["CHF", "CHF · Swiss franc"],
      ["SEK", "SEK kr · Swedish krona"], ["NOK", "NOK kr · Norwegian krone"], ["DKK", "DKK kr · Danish krone"], ["PLN", "PLN zł · Polish złoty"],
      ["CZK", "CZK Kč · Czech koruna"], ["HUF", "HUF Ft · Hungarian forint"], ["RON", "RON lei · Romanian leu"], ["ISK", "ISK kr · Icelandic króna"],
      ["TRY", "TRY ₺ · Turkish lira"], ["RSD", "RSD дин · Serbian dinar"], ["UAH", "UAH ₴ · Ukrainian hryvnia"], ["RUB", "RUB ₽ · Russian ruble"], ["ALL", "ALL L · Albanian lek"],
      ["BAM", "BAM KM · Convertible mark"], ["GEL", "GEL ₾ · Georgian lari"], ["MDL", "MDL lei · Moldovan leu"],
      ["CNY", "CNY ¥ · Chinese yuan"], ["JPY", "JPY ¥ · Japanese yen"], ["HKD", "HKD $ · Hong Kong dollar"], ["SGD", "SGD $ · Singapore dollar"],
      ["KRW", "KRW ₩ · South Korean won"], ["INR", "INR ₹ · Indian rupee"], ["THB", "THB ฿ · Thai baht"], ["MYR", "MYR RM · Malaysian ringgit"],
      ["IDR", "IDR Rp · Indonesian rupiah"], ["PHP", "PHP ₱ · Philippine peso"], ["VND", "VND ₫ · Vietnamese đồng"], ["PKR", "PKR ₨ · Pakistani rupee"],
      ["BDT", "BDT ৳ · Bangladeshi taka"], ["LKR", "LKR Rs · Sri Lankan rupee"], ["NPR", "NPR Rs · Nepalese rupee"],
      ["CAD", "CAD $ · Canadian dollar"], ["MXN", "MXN $ · Mexican peso"], ["BRL", "BRL R$ · Brazilian real"], ["ARS", "ARS $ · Argentine peso"],
      ["CLP", "CLP $ · Chilean peso"], ["COP", "COP $ · Colombian peso"], ["PEN", "PEN S/ · Peruvian sol"], ["UYU", "UYU $U · Uruguayan peso"], ["CRC", "CRC ₡ · Costa Rican colón"], ["JMD", "JMD $ · Jamaican dollar"], ["XCD", "XCD $ · East Caribbean dollar"],
      ["AUD", "AUD $ · Australian dollar"], ["NZD", "NZD $ · New Zealand dollar"], ["FJD", "FJD $ · Fijian dollar"],
      ["AED", "AED د.إ · UAE dirham"], ["SAR", "SAR ر.س · Saudi riyal"], ["ILS", "ILS ₪ · Israeli shekel"], ["QAR", "QAR ر.ق · Qatari riyal"], ["KWD", "KWD د.ك · Kuwaiti dinar"], ["BHD", "BHD د.ب · Bahraini dinar"], ["OMR", "OMR ر.ع. · Omani rial"], ["JOD", "JOD د.ا · Jordanian dinar"],
      ["ZAR", "ZAR R · South African rand"], ["EGP", "EGP £ · Egyptian pound"], ["MAD", "MAD د.م. · Moroccan dirham"], ["DZD", "DZD د.ج · Algerian dinar"], ["NGN", "NGN ₦ · Nigerian naira"], ["GHS", "GHS ₵ · Ghanaian cedi"], ["KES", "KES KSh · Kenyan shilling"], ["ETB", "ETB Br · Ethiopian birr"], ["UGX", "UGX USh · Ugandan shilling"], ["TZS", "TZS Sh · Tanzanian shilling"], ["BWP", "BWP P · Botswana pula"], ["MUR", "MUR ₨ · Mauritian rupee"], ["GMD", "GMD D · Gambian dalasi"], ["MZN", "MZN MT · Mozambican metical"], ["XAF", "XAF FCFA · Central African CFA franc"], ["XOF", "XOF CFA · West African CFA franc"], ["TND", "TND د.ت · Tunisian dinar"],
      ["TWD", "TWD NT$ · Taiwan dollar"], ["KZT", "KZT ₸ · Kazakhstani tenge"], ["AZN", "AZN ₼ · Azerbaijani manat"], ["AMD", "AMD ֏ · Armenian dram"], ["MKD", "MKD ден · Macedonian denar"], ["MOP", "MOP P · Macanese pataca"],
      ["BOB", "BOB Bs. · Bolivian boliviano"], ["DOP", "DOP RD$ · Dominican peso"], ["TTD", "TTD TT$ · Trinidad and Tobago dollar"], ["BBD", "BBD Bds$ · Barbadian dollar"], ["BSD", "BSD B$ · Bahamian dollar"], ["BZD", "BZD BZ$ · Belize dollar"], ["PYG", "PYG ₲ · Paraguayan guaraní"], ["GTQ", "GTQ Q · Guatemalan quetzal"], ["HNL", "HNL L · Honduran lempira"], ["NIO", "NIO C$ · Nicaraguan córdoba"], ["PAB", "PAB B/. · Panamanian balboa"], ["XPF", "XPF ₣ · CFP franc"]
    ];
    const localeMenu = (label, preference, options, fallback) => {
      const savedValue = localStorage.getItem(preference);
      const currentValue = options.some(([value]) => value === savedValue) ? savedValue : fallback;
      const currentLabel = options.find(([value]) => value === currentValue)?.[1] || fallback;
      return '<div class="trustbar-select-wrap trustbar-menu" data-locale-menu data-preference="' + preference + '">' +
        '<span class="sr-only">' + label + '</span>' +
        '<button type="button" class="trustbar-locale-trigger" aria-label="' + label + '" aria-haspopup="listbox" aria-expanded="false"><span data-locale-current>' + currentLabel + '</span><i aria-hidden="true">⌄</i></button>' +
        '<div class="trustbar-locale-options" role="listbox" aria-label="' + label + '" hidden>' +
          options.map(([value, optionLabel]) => '<button type="button" class="trustbar-locale-option" role="option" aria-selected="' + String(value === currentValue) + '" data-locale-value="' + value + '">' + optionLabel + '</button>').join("") +
        '</div></div>';
    };
    trustTopline.innerHTML =
      '<span class="trustbar-years"><b>10 YEARS</b><span>factory experience</span></span>' +
      '<div class="trustbar-proof" aria-label="Why choose Coolstar">' +
        '<span class="trustbar-item"><i aria-hidden="true">✓</i> Factory-direct supplier</span>' +
        '<span class="trustbar-item"><i aria-hidden="true">✓</i> Retail + wholesale</span>' +
        '<span class="trustbar-item"><i aria-hidden="true">✓</i> Custom OEM solutions</span>' +
      '</div>' +
      '<div class="trustbar-locales" aria-label="Language and currency">' +
        localeMenu("Language", "coolstar_language", languageOptions, "en") +
        '<span class="trustbar-divider" aria-hidden="true"></span>' +
        localeMenu("Currency", "coolstar_currency", currencyOptions, "USD") +
      '</div>';
    const localeFeedback = document.createElement("div");
    localeFeedback.className = "locale-feedback";
    localeFeedback.dataset.localeFeedback = "true";
    localeFeedback.setAttribute("role", "status");
    localeFeedback.setAttribute("aria-live", "polite");
    localeFeedback.hidden = true;
    trustTopline.insertAdjacentElement("afterend", localeFeedback);
    const localeMenus = Array.from(trustTopline.querySelectorAll("[data-locale-menu]"));
    const closeLocaleMenu = menu => {
      menu.querySelector(".trustbar-locale-trigger")?.setAttribute("aria-expanded", "false");
      const list = menu.querySelector(".trustbar-locale-options");
      if (list) list.hidden = true;
      menu.classList.remove("is-open");
    };
    localeMenus.forEach(menu => {
      const trigger = menu.querySelector(".trustbar-locale-trigger");
      const list = menu.querySelector(".trustbar-locale-options");
      const options = Array.from(menu.querySelectorAll("[data-locale-value]"));
      trigger?.addEventListener("click", () => {
        const shouldOpen = trigger.getAttribute("aria-expanded") !== "true";
        localeMenus.forEach(closeLocaleMenu);
        if (shouldOpen && list) {
          list.hidden = false;
          menu.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
          options.find(option => option.getAttribute("aria-selected") === "true")?.focus();
        }
      });
      list?.addEventListener("click", event => {
        const selectedOption = event.target.closest("[data-locale-value]");
        if (!selectedOption) return;
        options.forEach(option => option.setAttribute("aria-selected", String(option === selectedOption)));
        const current = menu.querySelector("[data-locale-current]");
        if (current) current.textContent = selectedOption.textContent;
        const selectedValue = selectedOption.dataset.localeValue;
        closeLocaleMenu(menu);
        trigger?.focus();
        if (menu.dataset.preference === LANGUAGE_KEY) {
          activeLanguage = selectedValue;
          localStorage.setItem(LANGUAGE_KEY, selectedValue);
          applyStoreLanguage();
          window.setPageLocale?.(selectedValue);
          refreshCurrencyDisplays();
          document.dispatchEvent(new Event("coolstar:store-language-changed"));
          showLocaleFeedback(t("updated"));
        } else {
          selectStoreCurrency(selectedValue);
        }
      });
      trigger?.addEventListener("keydown", event => {
        if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
        event.preventDefault();
        if (list?.hidden) trigger.click();
        else options[0]?.focus();
      });
      list?.addEventListener("keydown", event => {
        if (event.key === "Escape") { closeLocaleMenu(menu); trigger?.focus(); return; }
        if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
        event.preventDefault();
        const currentIndex = options.indexOf(document.activeElement);
        const direction = event.key === "ArrowDown" ? 1 : -1;
        options[(currentIndex + direction + options.length) % options.length]?.focus();
      });
    });
    document.addEventListener("click", event => {
      if (!event.target.closest("[data-locale-menu]")) localeMenus.forEach(closeLocaleMenu);
    });
  }
  const siteHeader = document.querySelector(".site-header");
  const headerNav = siteHeader?.querySelector(".main-nav");
  let refreshWelcomeGiftCopy = () => {};
  const megaMenuEnglish = {
    navHome: "Home",
    navCustom: "Custom",
    navSets: "Poker sets",
    navChips: "Poker chips",
    navTables: "Tables & chairs",
    navSupplies: "Poker supplies",
    navFactory: "Our factory",
    navContact: "Contact",
    customStudio: "CUSTOM DESIGN STUDIO",
    customChips: "Custom chip design",
    customSets: "Custom poker sets",
    customSupplies: "Poker supplies customization",
    savedDesigns: "My designs",
    numberHeading: "Number of chips",
    chipsWord: "chips",
    players46: "4–6 players",
    players68: "6–8 players",
    players810: "8–10 players",
    players10: "10+ players",
    moreSets: "More set options",
    materialHeading: "Material",
    claySet: "Clay poker sets",
    ceramicSet: "Ceramic poker sets",
    absSet: "ABS poker sets",
    ppSet: "PP poker sets",
    acrylicSet: "Acrylic poker sets",
    typesHeading: "Different types",
    tournamentSet: "Tournament poker sets",
    playerSet: "Venue & Club Sets",
    beginnerSet: "Beginner poker sets",
    professionalSet: "Professional poker sets",
    homeSet: "Casual poker sets",
    chipsHeading: "Shop chips",
    clayChips: "Clay chips",
    ceramicChips: "Ceramic chips",
    absChips: "ABS chips",
    ppChips: "PP chips",
    acrylicChips: "Acrylic chips",
    tablesHeading: "Poker tables",
    texasTable: "Texas Hold’em tables",
    blackjackTable: "Blackjack tables",
    rouletteTable: "Roulette tables",
    crapsTable: "Craps tables",
    tableAccessories: "Table accessories",
    matsHeading: "Table mats",
    texasMat: "Texas Hold’em mats",
    blackjackMat: "Blackjack mats",
    chairsHeading: "Poker chairs",
    texasChair: "Texas poker chair",
    suppliesHeading: "Cards & table essentials",
    playingCards: "Playing cards",
    dice: "Dice",
    dealerButton: "Dealer buttons",
    allInButton: "All-in buttons",
    callButton: "Call buttons",
    blindMarkers: "Blind markers",
    cutCards: "Cut cards",
    cardProtectors: "Card protectors",
    casesHeading: "Cases & accessories",
    chipCases: "Chip cases",
    chipRacks: "Chip racks",
    chipTrays: "Chip trays",
    cardSleeves: "Card sleeves",
    cashBoxes: "Cash boxes",
    contactHeading: "Talk with our team",
    contactPage: "Contact & quote request",
    whatsappMenu: "WhatsApp consultation",
    menuArrow: "↗"
  };
  const megaMenuChinese = {
    navHome: "首页",
    navCustom: "定制",
    navSets: "扑克套装",
    navChips: "扑克筹码",
    navTables: "桌椅",
    navSupplies: "扑克用品",
    navFactory: "工厂介绍",
    navContact: "联系我们",
    customStudio: "私人设计工作室",
    customChips: "筹码定制页",
    customSets: "套装定制页",
    customSupplies: "扑克用品定制",
    savedDesigns: "我的设计",
    numberHeading: "筹码数量",
    chipsWord: "枚筹码",
    players46: "4–6位玩家",
    players68: "6–8位玩家",
    players810: "8–10位玩家",
    players10: "10位以上",
    moreSets: "更多套装选项",
    materialHeading: "材质",
    claySet: "黏土套装",
    ceramicSet: "陶瓷套装",
    absSet: "ABS套装",
    ppSet: "PP套装",
    acrylicSet: "亚克力套装",
    typesHeading: "适用类型",
    tournamentSet: "锦标赛套装",
    playerSet: "场馆与俱乐部套装",
    beginnerSet: "初学者套装",
    professionalSet: "专业套装",
    homeSet: "休闲游戏套装",
    chipsHeading: "按材质选购筹码",
    clayChips: "黏土筹码",
    ceramicChips: "陶瓷筹码",
    absChips: "ABS筹码",
    ppChips: "PP筹码",
    acrylicChips: "亚克力筹码",
    tablesHeading: "桌类",
    texasTable: "德州扑克牌桌",
    blackjackTable: "21点桌",
    rouletteTable: "轮盘桌",
    crapsTable: "骰子桌",
    tableAccessories: "牌桌配件",
    matsHeading: "垫子类",
    texasMat: "德州垫子",
    blackjackMat: "21点垫子",
    chairsHeading: "椅子类",
    texasChair: "德州椅",
    suppliesHeading: "扑克牌与桌面用品",
    playingCards: "扑克牌",
    dice: "骰子",
    dealerButton: "庄家按钮",
    allInButton: "All-in牌",
    callButton: "Call牌",
    blindMarkers: "盲位牌",
    cutCards: "切牌",
    cardProtectors: "压牌码",
    casesHeading: "收纳与配件",
    chipCases: "筹码箱",
    chipRacks: "码耙",
    chipTrays: "码盘",
    cardSleeves: "牌套",
    cashBoxes: "现金箱",
    contactHeading: "联系 Coolstar 团队",
    contactPage: "联系我们 / 获取报价",
    whatsappMenu: "WhatsApp 咨询",
    menuArrow: "↗"
  };
  const megaMenuTraditional = {
    navHome: "首頁",
    navCustom: "客製",
    navSets: "撲克套裝",
    navChips: "撲克籌碼",
    navTables: "桌椅",
    navSupplies: "撲克用品",
    navFactory: "工廠介紹",
    navContact: "聯絡我們",
    customStudio: "私人設計工作室",
    customChips: "籌碼客製頁",
    customSets: "套裝客製頁",
    customSupplies: "撲克用品客製",
    savedDesigns: "我的設計",
    numberHeading: "籌碼數量",
    chipsWord: "枚籌碼",
    players46: "4–6 位玩家",
    players68: "6–8 位玩家",
    players810: "8–10 位玩家",
    players10: "10 位以上",
    moreSets: "更多套裝選項",
    materialHeading: "材質",
    claySet: "黏土套裝",
    ceramicSet: "陶瓷套裝",
    absSet: "ABS 套裝",
    ppSet: "PP 套裝",
    acrylicSet: "壓克力套裝",
    typesHeading: "適用類型",
    tournamentSet: "錦標賽套裝",
    playerSet: "場館與俱樂部套裝",
    beginnerSet: "初學者套裝",
    professionalSet: "專業套裝",
    homeSet: "休閒遊戲套裝",
    chipsHeading: "依材質選購籌碼",
    clayChips: "黏土籌碼",
    ceramicChips: "陶瓷籌碼",
    absChips: "ABS 籌碼",
    ppChips: "PP 籌碼",
    acrylicChips: "壓克力籌碼",
    tablesHeading: "桌類",
    texasTable: "德州撲克桌",
    blackjackTable: "21 點桌",
    rouletteTable: "輪盤桌",
    crapsTable: "骰子桌",
    tableAccessories: "牌桌配件",
    matsHeading: "桌墊類",
    texasMat: "德州桌墊",
    blackjackMat: "21 點桌墊",
    chairsHeading: "椅子類",
    texasChair: "德州椅",
    suppliesHeading: "撲克牌與桌面用品",
    playingCards: "撲克牌",
    dice: "骰子",
    dealerButton: "莊家按鈕",
    allInButton: "All-in 牌",
    callButton: "Call 牌",
    blindMarkers: "盲位牌",
    cutCards: "切牌",
    cardProtectors: "压牌碼",
    casesHeading: "收納與配件",
    chipCases: "籌碼箱",
    chipRacks: "碼耙",
    chipTrays: "碼盤",
    cardSleeves: "牌套",
    cashBoxes: "現金箱",
    contactHeading: "聯絡 Coolstar 團隊",
    contactPage: "聯絡我們 / 取得報價",
    whatsappMenu: "WhatsApp 諮詢",
    menuArrow: "↗"
  };
  const megaMenuLocales = { "zh-CN": megaMenuChinese, "zh-TW": megaMenuTraditional };
  const menuLabel = key => `<span data-mega-copy="${key}">${escapeHtml(megaMenuEnglish[key])}</span>`;
  const menuThumbnailFiles = {
    customSupplies: 'catalog-10.png', customChips: 'home-chips-materials.jpg', customSets: 'home-featured-set.jpg', savedDesigns: 'catalog-38.png',
    claySet: 'material-clay-studio-v2.png', ceramicSet: 'material-ceramic-studio-v2.png', absSet: 'material-abs-studio-v2.png', ppSet: 'material-pp-studio-v2.png', acrylicSet: 'material-acrylic-studio-v2.png',
    tournamentSet: 'catalog-60.jpg', professionalSet: 'catalog-60.jpg', beginnerSet: 'catalog-01.jpg', playerSet: 'home-featured-set.jpg', homeSet: 'catalog-00.jpg', moreSets: 'home-poker-set.jpg',
    clayChips: 'material-clay-studio-v2.png', ceramicChips: 'material-ceramic-studio-v2.png', absChips: 'material-abs-studio-v2.png', ppChips: 'material-pp-studio-v2.png', acrylicChips: 'material-acrylic-studio-v2.png',
    texasTable: 'catalog-21.jpg', blackjackTable: 'catalog-29.jpg', rouletteTable: 'catalog-43.jpg', crapsTable: 'catalog-34.jpg', tableAccessories: 'table-accessory-roulette-wheel-v2.png', texasMat: 'catalog-40.jpg', blackjackMat: 'catalog-41.jpg', texasChair: 'catalog-28.jpg',
    playingCards: 'catalog-10.png', dice: 'catalog-13.png', dealerButton: 'catalog-31.jpg', allInButton: 'catalog-84.jpg', callButton: 'catalog-83.jpg', blindMarkers: 'catalog-83.jpg', cutCards: 'catalog-10.png', cardProtectors: 'catalog-55.jpg',
    chipCases: 'catalog-08.jpg', chipRacks: 'catalog-62.jpg', chipTrays: 'catalog-80.jpg', cardSleeves: 'catalog-61.jpg', cashBoxes: 'catalog-77.jpg', contactPage: 'home-factory-workshop.jpg', whatsappMenu: 'whatsapp-logo.svg'
  };
  const menuThumbnail = file => `<img class="mega-menu-thumb" src="${escapeHtml((window.CoolstarShopifyTheme?.assets?.navigationBase || 'assets/images/') + file)}" alt="" aria-hidden="true" width="44" height="44" loading="lazy">`;
  const menuLink = (href, key, extraClass = "") => `<a${extraClass ? ` class="${extraClass}"` : ""} href="${href}">${menuThumbnail(menuThumbnailFiles[key] || 'home-featured-set.jpg')}${menuLabel(key)}<i aria-hidden="true">↗</i></a>`;
  if (siteHeader) {
    const brand = siteHeader.querySelector(".brand");
    if (!siteHeader.querySelector(".header-search")) {
      const searchForm = document.createElement("form");
      searchForm.className = "header-search";
      searchForm.setAttribute("role", "search");
      searchForm.action = "products.html";
      searchForm.method = "get";
      searchForm.innerHTML = '<label class="sr-only" for="header-search-input">Search products</label><input id="header-search-input" type="search" name="q" placeholder="Search..." autocomplete="off" aria-controls="header-search-popover" aria-expanded="false" required><button type="submit" aria-label="Search"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.8" cy="10.8" r="6.2"></circle><path d="m15.4 15.4 5 5"></path></svg></button><div class="search-popover" id="header-search-popover" data-search-popover hidden><section class="search-history"><div class="search-popover-heading"><b>Recent searches</b><button type="button" data-clear-search-history>Clear all</button></div><div class="search-history-list" data-search-history-list></div></section><section class="search-recommendations"><div class="search-popover-heading"><b>Recommended products</b></div><a class="search-recommendation" href="500-chip-set.html"><img src="https://www.coolstarpoker.com/cdn/shop/files/coolstar-poker-banner-04.jpg?v=1782814088&width=120&quality=70" alt=""><span><b>500-piece poker set</b><small>Ready for game night</small></span><i aria-hidden="true">↗</i></a><a class="search-recommendation" href="product-detail.html"><img src="https://www.coolstarpoker.com/cdn/shop/files/coolstar-poker-banner-02.jpg?v=1782813806&width=120&quality=70" alt=""><span><b>Custom poker chips</b><small>Explore materials and designs</small></span><i aria-hidden="true">↗</i></a><a class="search-recommendation" href="products.html#tables"><img src="https://www.coolstarpoker.com/cdn/shop/files/coolstar-poker-banner-03.jpg?v=1782813959&width=120&quality=70" alt=""><span><b>Poker tables</b><small>Find the right table for your venue</small></span><i aria-hidden="true">↗</i></a></section></div>';
      brand?.insertAdjacentElement("afterend", searchForm);
    }
    if (headerNav) {
      let customLink = headerNav.querySelector('a[href="custom.html"]');
      if (!customLink) {
        customLink = document.createElement("a");
        customLink.href = "custom.html";
        customLink.textContent = "Custom & OEM";
        const aboutLink = headerNav.querySelector('a[href="about.html"]');
        headerNav.insertBefore(customLink, aboutLink || null);
      }
      customLink.dataset.nav = "custom";
      let accountLink = headerNav.querySelector('a[href="account.html"]');
      if (!accountLink) {
        accountLink = document.createElement("a");
        accountLink.href = "account.html";
        headerNav.appendChild(accountLink);
      }
      accountLink.dataset.nav = "account";
      accountLink.className = "header-action-link header-account-action";
      accountLink.setAttribute("aria-label", "Sign in to your account");
      accountLink.innerHTML = '<span class="header-action-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.5"></circle><path d="M4.5 21v-1.5a7.5 7.5 0 0 1 15 0V21"></path></svg></span><span class="header-action-copy"><small>Sign in</small><b>My account</b></span>';
      customLink.className = "header-action-link header-custom-action";
      customLink.setAttribute("aria-label", "Explore custom and OEM options");
      customLink.innerHTML = '<span class="header-action-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"></circle><circle cx="12" cy="12" r="4"></circle><path d="M12 1.5v3M12 19.5v3M1.5 12h3M19.5 12h3"></path></svg></span><span class="header-action-copy"><small>Design your own</small><b>Custom &amp; OEM</b></span>';
      customLink.remove();
      accountLink.remove();

      const headerTopRow = siteHeader.querySelector(".header-primary-row") || document.createElement("div");
      const headerActions = siteHeader.querySelector(".header-actions") || document.createElement("div");
      headerTopRow.className = "header-primary-row";
      headerActions.className = "header-actions";
      const menuToggle = siteHeader.querySelector(".menu-toggle");
      const quoteLink = siteHeader.querySelector(".header-cta");
      const cartLink = siteHeader.querySelector(".cart-link");
      const headerSearchForm = siteHeader.querySelector(".header-search");
      const welcomeButton = document.createElement("button");
      welcomeButton.type = "button";
      welcomeButton.className = "header-action-link header-welcome-action";
      welcomeButton.setAttribute("aria-haspopup", "dialog");
      welcomeButton.setAttribute("aria-controls", "account-offer-modal");
      welcomeButton.innerHTML = '<span class="welcome-gift-mark" aria-hidden="true">✦</span><span class="header-action-copy"><small data-welcome-copy="kicker">First order offer</small><b data-welcome-copy="button">Welcome gift</b></span>';
      if (quoteLink) {
        const quoteContent = 'Get a quote <span aria-hidden="true">↗</span>';
        const quoteHref = "wholesale.html";
        const customHref = customLink.getAttribute("href") || "custom.html";
        const quoteLabel = "Get a quote";
        quoteLink.href = customHref;
        quoteLink.dataset.nav = "custom";
        quoteLink.classList.add("header-cta-custom");
        quoteLink.setAttribute("aria-label", "Design your own custom poker products");
        quoteLink.innerHTML = '<span class="header-custom-mark" aria-hidden="true"></span><span class="header-cta-copy"><small>Made for your brand</small><b>Custom &amp; OEM</b><em>Design your own custom chips</em></span><span class="header-cta-arrow" aria-hidden="true">↗</span>';
        customLink.href = quoteHref;
        customLink.className = "header-action-link header-quote-action";
        customLink.removeAttribute("data-nav");
        if (quoteLabel) customLink.setAttribute("aria-label", quoteLabel);
        else customLink.removeAttribute("aria-label");
        customLink.innerHTML = quoteContent;
      }
      if (!headerTopRow.parentElement) siteHeader.prepend(headerTopRow);
      let brandSearchGroup = headerTopRow.querySelector(".header-brand-search");
      if (!brandSearchGroup) {
        brandSearchGroup = document.createElement("div");
        brandSearchGroup.className = "header-brand-search";
      }
      headerTopRow.append(...[brandSearchGroup, menuToggle, quoteLink, headerActions].filter(Boolean));
      brandSearchGroup.append(...[brand, headerSearchForm].filter(Boolean));
      headerActions.append(...[welcomeButton, customLink, accountLink, cartLink].filter(Boolean));

      refreshWelcomeGiftCopy = () => {
        welcomeButton.querySelector('[data-welcome-copy="kicker"]')?.replaceChildren(document.createTextNode(welcomeText("kicker")));
        welcomeButton.querySelector('[data-welcome-copy="button"]')?.replaceChildren(document.createTextNode(welcomeText("button")));
        welcomeButton.setAttribute("aria-label", welcomeText("button"));
      };
      refreshWelcomeGiftCopy();
      welcomeButton.addEventListener("click", () => document.dispatchEvent(new CustomEvent("coolstar:open-account-offer")));
      headerNav.innerHTML =
        '<a class="nav-direct nav-home" data-nav="home" href="index.html">' + menuLabel("navHome") + '</a>' +
        '<div class="nav-mega-group" data-nav="custom"><button type="button" class="nav-mega-trigger" aria-expanded="false">' + menuLabel("navCustom") + '<i aria-hidden="true">⌄</i></button><div class="mega-menu mega-menu-compact" aria-hidden="true"><div class="mega-menu-column"><p class="mega-menu-kicker">' + menuLabel("customStudio") + '</p>' + menuLink("chip-customizer.html", "customChips") + menuLink("set-customizer.html", "customSets") + menuLink("poker-supplies-customizer.html", "customSupplies") + menuLink("my-designs.html", "savedDesigns") + '</div></div></div>' +
        '<div class="nav-mega-group" data-nav="sets"><button type="button" class="nav-mega-trigger" aria-expanded="false">' + menuLabel("navSets") + '<i aria-hidden="true">⌄</i></button><div class="mega-menu mega-menu-columns mega-menu-sets" aria-hidden="true">' +
          '<div class="mega-menu-column mega-set-count"><h3>' + menuLabel("numberHeading") + '</h3><div class="mega-count-grid"><a href="poker-sets-300.html"><b>300</b><span>' + menuLabel("chipsWord") + '</span><small>' + menuLabel("players46") + '</small></a><a href="poker-sets-500.html"><b>500</b><span>' + menuLabel("chipsWord") + '</span><small>' + menuLabel("players68") + '</small></a><a href="poker-sets-750.html"><b>750</b><span>' + menuLabel("chipsWord") + '</span><small>' + menuLabel("players810") + '</small></a><a href="poker-sets-1000.html"><b>1,000</b><span>' + menuLabel("chipsWord") + '</span><small>' + menuLabel("players10") + '</small></a></div>' + menuLink("poker-sets.html", "moreSets", "mega-more-link") + '</div>' +
          '<div class="mega-menu-column"><h3>' + menuLabel("materialHeading") + '</h3>' + menuLink("poker-sets-clay.html", "claySet") + menuLink("poker-sets-ceramic.html", "ceramicSet") + menuLink("poker-sets-abs.html", "absSet") + menuLink("poker-sets-pp.html", "ppSet") + menuLink("poker-sets-acrylic.html", "acrylicSet") + '</div>' +
          '<div class="mega-menu-column"><h3>' + menuLabel("typesHeading") + '</h3>' + menuLink("poker-sets-tournament.html", "tournamentSet") + menuLink("poker-sets-professional.html", "professionalSet") + menuLink("poker-sets-beginner.html", "beginnerSet") + menuLink("poker-sets-venue.html", "playerSet") + menuLink("poker-sets-casual.html", "homeSet") + '</div></div></div>' +
        '<div class="nav-mega-group" data-nav="chips"><button type="button" class="nav-mega-trigger" aria-expanded="false">' + menuLabel("navChips") + '<i aria-hidden="true">⌄</i></button><div class="mega-menu mega-menu-compact" aria-hidden="true"><div class="mega-menu-column"><h3>' + menuLabel("chipsHeading") + '</h3>' + menuLink("poker-chips-clay.html", "clayChips") + menuLink("poker-chips-ceramic.html", "ceramicChips") + menuLink("poker-chips-abs.html", "absChips") + menuLink("poker-chips-pp.html", "ppChips") + menuLink("poker-chips-acrylic.html", "acrylicChips") + '</div></div></div>' +
        '<div class="nav-mega-group" data-nav="tables"><button type="button" class="nav-mega-trigger" aria-expanded="false">' + menuLabel("navTables") + '<i aria-hidden="true">⌄</i></button><div class="mega-menu mega-menu-columns mega-menu-tables" aria-hidden="true"><div class="mega-menu-column"><h3>' + menuLabel("tablesHeading") + '</h3>' + menuLink("tables-chairs-texas.html", "texasTable") + menuLink("tables-chairs-blackjack.html", "blackjackTable") + menuLink("tables-chairs-roulette.html", "rouletteTable") + menuLink("tables-chairs-craps.html", "crapsTable") + menuLink("tables-chairs-table-accessories.html", "tableAccessories") + '</div><div class="mega-menu-column"><h3>' + menuLabel("matsHeading") + '</h3>' + menuLink("tables-chairs-texas-mats.html", "texasMat") + menuLink("tables-chairs-blackjack-mats.html", "blackjackMat") + '</div><div class="mega-menu-column"><h3>' + menuLabel("chairsHeading") + '</h3>' + menuLink("tables-chairs-chairs.html", "texasChair") + '</div></div></div>' +
        '<div class="nav-mega-group" data-nav="supplies"><button type="button" class="nav-mega-trigger" aria-expanded="false">' + menuLabel("navSupplies") + '<i aria-hidden="true">⌄</i></button><div class="mega-menu mega-menu-columns mega-menu-two mega-menu-supplies" aria-hidden="true"><div class="mega-menu-column"><h3>' + menuLabel("suppliesHeading") + '</h3>' + menuLink("poker-supplies-cards.html", "playingCards") + menuLink("poker-supplies-dice.html", "dice") + menuLink("poker-supplies-dealer.html", "dealerButton") + menuLink("poker-supplies-all-in.html", "allInButton") + menuLink("poker-supplies-call.html", "callButton") + menuLink("poker-supplies-blinds.html", "blindMarkers") + menuLink("poker-supplies-cut-cards.html", "cutCards") + menuLink("poker-supplies-guards.html", "cardProtectors") + '</div><div class="mega-menu-column"><h3>' + menuLabel("casesHeading") + '</h3>' + menuLink("poker-supplies-cases.html", "chipCases") + menuLink("poker-supplies-racks.html", "chipRacks") + menuLink("poker-supplies-trays.html", "chipTrays") + menuLink("poker-supplies-sleeves.html", "cardSleeves") + menuLink("poker-supplies-cash.html", "cashBoxes") + '</div></div></div>' +
        '<a class="nav-direct" data-nav="about" href="about.html">' + menuLabel("navFactory") + '</a>' +
        '<div class="nav-mega-group" data-nav="contact"><button type="button" class="nav-mega-trigger" aria-expanded="false">' + menuLabel("navContact") + '<i aria-hidden="true">⌄</i></button><div class="mega-menu mega-menu-compact mega-menu-contact" aria-hidden="true"><div class="mega-menu-column"><p class="mega-menu-kicker">' + menuLabel("contactHeading") + '</p>' + menuLink("contact.html#quote-form", "contactPage") + menuLink("https://wa.me/" + CONFIG.whatsappNumber.replace(/\D/g,""), "whatsappMenu") + '</div></div></div>';

      // Category names navigate; the adjacent button only expands the submenu.
      const categoryHomes = {custom:'custom.html#custom-chips', sets:'poker-sets.html', chips:'poker-chips.html', tables:'tables-chairs.html', supplies:'poker-supplies.html', contact:'contact.html#quote-form'};
      headerNav.querySelectorAll('.nav-mega-group').forEach(group => {
        const button = group.querySelector('.nav-mega-trigger');
        const label = button.querySelector('[data-mega-copy]');
        const heading = document.createElement('div'); heading.className = 'nav-mega-heading';
        const link = document.createElement('a'); link.className = 'nav-mega-home'; link.href = categoryHomes[group.dataset.nav];
        button.setAttribute('aria-label', 'Expand ' + label.textContent);
        const panel = group.querySelector('.mega-menu'); panel.id = 'mega-panel-' + group.dataset.nav;
        button.setAttribute('aria-controls', panel.id);
        link.append(label); heading.append(link,button); group.prepend(heading);
        link.addEventListener('keydown', event => { if(event.key==='ArrowDown'){ event.preventDefault(); button.click(); panel.querySelector('a')?.focus(); } });
      });
      siteHeader.querySelector('.header-cta-custom')?.setAttribute('href','custom.html#custom-chips');
      headerNav.querySelectorAll('.mega-count-grid>a').forEach(link => {
        const copy = document.createElement('span'); copy.className = 'mega-count-copy'; copy.append(...link.childNodes); link.append(copy);
        link.insertAdjacentHTML('afterbegin', menuThumbnail('home-featured-set.jpg'));
      });
      let headerNavRow = siteHeader.querySelector(".header-nav-row");
      if (!headerNavRow) {
        headerNavRow = document.createElement("div");
        headerNavRow.className = "header-nav-row";
        headerTopRow.insertAdjacentElement("afterend", headerNavRow);
      }
      headerNavRow.appendChild(headerNav);
    }
    const headerSearchForm = siteHeader.querySelector(".header-search");
    const headerSearchInput = headerSearchForm?.querySelector('input[name="q"]');
    const searchPopover = siteHeader.querySelector("[data-search-popover]");
    const searchHistoryList = siteHeader.querySelector("[data-search-history-list]");
    const searchHistoryKey = "coolstar_search_history_v1";
    const initialSearch = new URLSearchParams(location.search).get("q")?.trim() || "";
    if (headerSearchInput && document.body.dataset.page === "products" && initialSearch) headerSearchInput.value = initialSearch;
    if (headerSearchInput && searchPopover && searchHistoryList) {
      let searchPopoverOpen = false;
      const getSearchHistory = () => {
        const stored = readJson(searchHistoryKey, []);
        return Array.isArray(stored) ? stored.filter(value => typeof value === "string" && value.trim()).slice(0, 8) : [];
      };
      const renderSearchHistory = () => {
        const history = getSearchHistory();
        searchHistoryList.innerHTML = history.length
          ? history.map(term => `<div class="search-history-row"><button type="button" class="search-history-term" data-search-term="${escapeHtml(term)}"><span aria-hidden="true">◷</span>${escapeHtml(term)}</button><button type="button" class="search-history-remove" data-remove-search-term="${escapeHtml(term)}" aria-label="Remove ${escapeHtml(term)} from search history">×</button></div>`).join("")
          : '<p class="search-history-empty">Your recent searches will appear here.</p>';
      };
      const positionSearchPopover = () => {
        const bounds = headerSearchForm.getBoundingClientRect();
        const panelWidth = Math.min(380, window.innerWidth - 16);
        const left = Math.max(8 - bounds.left, Math.min(0, window.innerWidth - 8 - (bounds.left + panelWidth)));
        searchPopover.style.left = `${left}px`;
        searchPopover.style.width = `${panelWidth}px`;
      };
      const closeSearchPopover = () => {
        searchPopoverOpen = false;
        searchPopover.hidden = true;
        headerSearchInput.setAttribute("aria-expanded", "false");
        headerSearchForm.classList.remove("search-is-open");
      };
      const openSearchPopover = () => {
        if (headerSearchInput.value.trim()) return closeSearchPopover();
        renderSearchHistory();
        positionSearchPopover();
        searchPopover.hidden = false;
        searchPopoverOpen = true;
        headerSearchInput.setAttribute("aria-expanded", "true");
        headerSearchForm.classList.add("search-is-open");
      };
      headerSearchInput.addEventListener("focus", openSearchPopover);
      headerSearchInput.addEventListener("click", openSearchPopover);
      headerSearchInput.addEventListener("input", () => {
        if (headerSearchInput.value.trim()) closeSearchPopover();
        else if (searchPopoverOpen) openSearchPopover();
      });
      headerSearchForm.addEventListener("submit", () => {
        const term = headerSearchInput.value.trim();
        if (!term) return;
        const history = getSearchHistory().filter(value => value.toLocaleLowerCase() !== term.toLocaleLowerCase());
        writeJson(searchHistoryKey, [term, ...history].slice(0, 8));
      });
      searchPopover.addEventListener("click", event => {
        const clearButton = event.target.closest("[data-clear-search-history]");
        if (clearButton) {
          writeJson(searchHistoryKey, []);
          renderSearchHistory();
          return;
        }
        const removeButton = event.target.closest("[data-remove-search-term]");
        if (removeButton) {
          const term = removeButton.dataset.removeSearchTerm;
          writeJson(searchHistoryKey, getSearchHistory().filter(value => value !== term));
          renderSearchHistory();
          return;
        }
        const termButton = event.target.closest("[data-search-term]");
        if (termButton) {
          headerSearchInput.value = termButton.dataset.searchTerm;
          headerSearchForm.requestSubmit();
        }
      });
      document.addEventListener("pointerdown", event => {
        if (searchPopoverOpen && !headerSearchForm.contains(event.target)) closeSearchPopover();
      });
      headerSearchInput.addEventListener("keydown", event => {
        if (event.key === "Escape") closeSearchPopover();
      });
      window.addEventListener("resize", () => { if (searchPopoverOpen) positionSearchPopover(); });
    }
    const productGrid = document.querySelector(".product-grid");
    if (productGrid && initialSearch) {
      const normalizedSearch = initialSearch.toLocaleLowerCase();
      const cards = Array.from(productGrid.querySelectorAll(".product-card"));
      let resultCount = 0;
      cards.forEach(card => {
        const matches = card.textContent.toLocaleLowerCase().includes(normalizedSearch);
        card.hidden = !matches;
        if (matches) resultCount += 1;
      });
      const resultNotice = document.createElement("p");
      resultNotice.className = "product-search-status wrap";
      resultNotice.setAttribute("role", "status");
      resultNotice.textContent = resultCount
        ? `${resultCount} product${resultCount === 1 ? "" : "s"} matching “${initialSearch}”`
        : `No products found for “${initialSearch}”. Try chips, tables or sets.`;
      productGrid.parentNode.insertBefore(resultNotice, productGrid);
    }
  }
  const showLocaleFeedback = message => {
    const node = document.querySelector("[data-locale-feedback]");
    if (!node) return;
    node.textContent = message;
    node.hidden = false;
    window.clearTimeout(node.hideTimer);
    node.hideTimer = window.setTimeout(() => { node.hidden = true; }, 4200);
  };
  const applyStoreLanguage = () => {
    document.documentElement.lang = activeLanguage;
    document.documentElement.dir = activeLanguage === "ar" ? "rtl" : "ltr";
    refreshWelcomeGiftCopy();
    const localizedMegaMenu = megaMenuLocales[activeLanguage] || megaMenuEnglish;
    document.querySelectorAll(".main-nav [data-main-label], .main-nav [data-mega-copy]").forEach(node => {
      const key = node.dataset.mainLabel || node.dataset.megaCopy;
      const label = localizedMegaMenu[key] || megaMenuEnglish[key];
      if (label) node.textContent = label;
    });
    document.querySelector(".trustbar-years>span")?.replaceChildren(document.createTextNode(t("experience")));
    const proofKeys = ["supplier", "retail", "solutions"];
    document.querySelectorAll(".trustbar-item").forEach((item, index) => {
      const key = proofKeys[index];
      if (key) item.innerHTML = '<i aria-hidden="true">✓</i> ' + escapeHtml(t(key));
    });
    const search = document.querySelector("#header-search-input");
    if (search) search.placeholder = t("search");
    const searchLabel = document.querySelector('.header-search label[for="header-search-input"]');
    if (searchLabel) searchLabel.textContent = t("search");
    const searchButton = document.querySelector(".header-search button[type=submit]");
    if (searchButton) searchButton.setAttribute("aria-label", t("search"));
    const customCta = document.querySelector(".header-cta-custom .header-cta-copy");
    if (customCta) {
      customCta.querySelector("small")?.replaceChildren(document.createTextNode(t("made")));
      customCta.querySelector("b")?.replaceChildren(document.createTextNode(t("custom")));
      customCta.querySelector("em")?.replaceChildren(document.createTextNode(t("chips")));
    }
    const quoteAction = document.querySelector(".header-actions .header-quote-action");
    if (quoteAction) {
      const label = t("quote");
      quoteAction.setAttribute("aria-label", label);
      quoteAction.innerHTML = escapeHtml(label) + ' <span aria-hidden="true">↗</span>';
    }
    const accountAction = document.querySelector(".header-account-action");
    if (accountAction && accountAction.dataset.signedIn !== "true") {
      accountAction.setAttribute("aria-label", t("signIn") + " · " + t("myAccount"));
      accountAction.querySelector(".header-action-copy small")?.replaceChildren(document.createTextNode(t("signIn")));
      accountAction.querySelector(".header-action-copy b")?.replaceChildren(document.createTextNode(t("myAccount")));
    }
    document.querySelectorAll(".cart-link").forEach(link => {
      link.setAttribute("aria-label", t("cart"));
      const labelNode = Array.from(link.childNodes).find(child => child.nodeType === Node.TEXT_NODE);
      if (labelNode) labelNode.textContent = t("cart") + " ";
    });
    document.querySelectorAll("[data-locale-menu]").forEach(menu => {
      const trigger = menu.querySelector(".trustbar-locale-trigger");
      if (trigger) trigger.setAttribute("aria-label", menu.dataset.preference === LANGUAGE_KEY ? "Language" : "Currency");
    });
  };
  const currentPageKey = document.body.dataset.page;
  const currentMenuKey = ({"poker-sets":"sets","poker-chips":"chips","tables-chairs":"tables","poker-supplies":"supplies"})[currentPageKey] || (currentPageKey === "landing" ? "sets"
    : currentPageKey === "product" ? "chips"
      : currentPageKey === "products"
        ? (location.hash.includes("sets") ? "sets" : location.hash.includes("tables") ? "tables" : location.hash.includes("accessories") || location.hash.includes("cards") ? "supplies" : "chips")
        : currentPageKey === "wholesale" ? "contact" : currentPageKey === "designs" ? "custom" : currentPageKey);
  document.querySelectorAll(".main-nav [data-nav]").forEach(item => {
    const active = item.dataset.nav === currentMenuKey;
    item.classList.toggle("active", active);
    if (active) item.setAttribute("aria-current", "page"); else item.removeAttribute("aria-current");
  });
  document.querySelectorAll(".chip-rail [data-nav]").forEach(item => {
    const active = item.dataset.nav === currentPageKey || ((currentPageKey === "products" || currentPageKey === "product") && item.dataset.nav === "products");
    item.classList.toggle("active", active);
    if (active) item.setAttribute("aria-current", "page"); else item.removeAttribute("aria-current");
  });
  // A fixed chip rail gives retail buyers and business buyers a one-click route
  // to the most-used destinations on every page.
  const railGlyphs = {
    Shop:'<path d="M5 8h14l1 12H4L5 8Z"/><path d="M8 8V6a4 4 0 0 1 8 0v2"/>',
    Chips:'<ellipse cx="12" cy="6" rx="8" ry="3"/><path d="M4 6v4c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 11v4c0 1.7 3.6 3 8 3s8-1.3 8-3v-4M4 16v2c0 1.7 3.6 3 8 3s8-1.3 8-3v-2"/>',
    Set:'<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V4h8v3M3 12h18M8 11v3M16 11v3"/>',
    Bulk:'<path d="m3 7 9-4 9 4v11l-9 4-9-4V7Zm0 0 9 4 9-4M12 11v11M7 5l9 4"/>',
    Custom:'<path d="m5 15-1 5 5-1L20 8l-4-4L5 15ZM13 7l4 4M5 15l4 4"/><path d="M14 21h7"/>',
    Factory:'<path d="M3 21V10l6 3V8l6 4V3h4v18H3ZM15 6h4M7 17h1M11 17h1M16 17h1"/>',
    Ship:'<path d="M3 5h11v12H3V5ZM14 9h4l3 4v4h-7M14 13h7"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
    Quote:'<path d="M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-5 3v-3H3V6a2 2 0 0 1 2-2Z"/><path d="M7 8h10M7 12h7"/>'
  };
  const railGlyph = name => '<svg class="rail-purpose-icon" viewBox="0 0 24 24" aria-hidden="true">' + railGlyphs[name] + '</svg>';
  if (!document.querySelector(".chip-rail")) {
    const rail = document.createElement("nav");
    rail.className = "chip-rail";
    rail.setAttribute("aria-label", "Quick navigation");
    const routes = [
      ["index.html", "home", "C", "Home"],
      ["products.html", "products", "♠", "Shop"],
      ["500-chip-set.html", "landing", "500", "Set"],
      ["wholesale.html", "wholesale", "W", "Bulk"],
      ["custom.html", "custom", "✳", "Custom"],
      ["about.html", "about", "10", "Factory"],
      ["shipping.html", "shipping", "➜", "Ship"],
      ["contact.html", "contact", "?", "Quote"]
    ];
    const currentPage = document.body.dataset.page;
    const homeCurrent = currentPage === "home" ? ' aria-current="page"' : "";
    rail.innerHTML = `<a class="rail-logo" href="index.html" aria-label="Coolstar home"${homeCurrent}>C</a>${routes.slice(1).map(([href, page, icon, label]) => {
      const active = currentPage === page || (currentPage === "product" && page === "products");
      return `<a href="${href}" aria-label="${label}"${active ? ' aria-current="page"' : ""}><span class="rail-coin" aria-hidden="true"><span class="rail-icon">${railGlyphs[label] ? railGlyph(label) : icon}</span></span><span>${label}</span></a>`;
    }).join("")}`;
    document.body.insertBefore(rail, document.body.firstChild);
  }

  // On the home page the chip rail locates sections; other pages retain direct routes.
  if (document.body.dataset.page === "home") {
    const homeRail = document.querySelector(".chip-rail");
    const locations = [
      ["home-top", ".table-home, .editorial-hero", "Back to the top"],
      ["home-collection", ".collection-room", "Browse the collection"],
      ["retail-set-feature", ".retail-feature", "Explore poker sets"],
      ["home-materials", ".home-materials", "Choose chip materials"],
      ["home-custom", ".custom-route, .editorial-custom", "Custom and OEM projects"],
      ["factory-story", ".factory-story", "Meet our factory"],
      ["home-help", ".help-desk", "Shipping and order information"],
      ["home-contact", ".site-footer", "Contact the Coolstar team"]
    ];
    const links = Array.from(homeRail?.querySelectorAll("a") || []);
    const points = locations.map(([id,selector,label],index) => {
      const target=document.getElementById(id) || document.querySelector(selector);
      const link=links[index];
      if(!target || !link) return null;
      target.id=id;
      if(!target.hasAttribute("tabindex")) target.setAttribute("tabindex","-1");
      link.href="#"+id;
      link.dataset.homeTarget=id;
      const purpose = {'home-collection':'Shop','home-materials':'Chips','retail-set-feature':'Set','home-custom':'Custom','factory-story':'Factory','home-help':'Ship','home-contact':'Quote'}[id];
      if(purpose)link.querySelector('.rail-icon').innerHTML=railGlyph(purpose);
      if(id==='home-materials')link.lastElementChild.textContent='Chips';
      link.setAttribute("aria-label",label);
      link.title=label;
      link.removeAttribute("aria-current");
      return {target,link,id};
    }).filter(Boolean);
    // Mirror the real content order, including the independently designed backup.
    points.sort((a,b)=>a.target.compareDocumentPosition(b.target)&Node.DOCUMENT_POSITION_FOLLOWING?-1:1);
    if(homeRail){
      homeRail.setAttribute("aria-label","On this page");
      points.forEach(point=>homeRail.appendChild(point.link));
    }
    const headerOffset=()=>Math.max(0,document.querySelector(".site-header")?.getBoundingClientRect().height || 0)+22;
    const setCurrent=point=>points.forEach(item=>{
      const active=item===point;
      item.link.classList.toggle("active",active);
      if(active)item.link.setAttribute("aria-current","location");
      else item.link.removeAttribute("aria-current");
    });
    const updateLocation=()=>{
      const sorted=[...points].sort((a,b)=>a.target.getBoundingClientRect().top-b.target.getBoundingClientRect().top);
      let current=sorted[0];
      for(const point of sorted)if(point.target.getBoundingClientRect().top<=headerOffset()+8)current=point;
      if(innerHeight+scrollY>=document.documentElement.scrollHeight-4)current=sorted.at(-1);
      if(current)setCurrent(current);
    };
    const goTo=(point,focus=false)=>{
      const top=point.id==="home-top" ? 0 : Math.max(0,scrollY+point.target.getBoundingClientRect().top-headerOffset());
      window.scrollTo({top,behavior:matchMedia("(prefers-reduced-motion: reduce)").matches?"instant":"smooth"});
      if(focus)point.target.focus({preventScroll:true});
      setCurrent(point);
    };
    points.forEach(point=>point.link.addEventListener("click",event=>{
      if(event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
      event.preventDefault();
      if(location.hash!=="#"+point.id)history.pushState(null,"","#"+point.id);
      goTo(point,true);
    }));
    let scheduled=false;
    window.addEventListener("scroll",()=>{
      if(scheduled)return;
      scheduled=true;
      requestAnimationFrame(()=>{scheduled=false;updateLocation();});
    },{passive:true});
    window.addEventListener("resize",updateLocation);
    const restoreHash=()=>{
      const point=points.find(item=>"#"+item.id===location.hash);
      if(point)goTo(point);else updateLocation();
    };
    window.addEventListener("hashchange",restoreHash);
    window.addEventListener("load",restoreHash,{once:true});
    updateLocation();
  }

  // Desktop quick links unfold above and below the home coin after hover intent.
  const foldingRail = document.querySelector('.chip-rail');
  const railHome = foldingRail?.querySelector('.rail-logo');
  if (foldingRail && railHome) {
    const railLinks = [...foldingRail.querySelectorAll('a:not(.rail-logo)')];
    const desktopRail = matchMedia('(min-width: 901px)');
    const upperCount = Math.floor(railLinks.length / 2);
    let railOpen = document.body.dataset.page === 'home', openTimer, closeTimer, suppressFocus = false, swallowTouchClick = false;
    let railIntro = railOpen, introTimer, firstDownwardScroll = false, introLastY = window.scrollY;
    const finishRailIntro = () => { railIntro = false; clearTimeout(introTimer); };
    window.addEventListener('scroll', () => {
      const nextY = window.scrollY;
      if (railIntro && !firstDownwardScroll && nextY > introLastY && nextY > 12) {
        firstDownwardScroll = true;
        introTimer = setTimeout(() => { finishRailIntro(); if (!foldingRail.matches(':hover') && !foldingRail.contains(document.activeElement)) paintRail(false); }, 1200);
      }
      introLastY = nextY;
    }, {passive:true});
    const railPositionKey = 'coolstar_rail_position_v1';
    let railRatio = readJson(railPositionKey, null), railBounds = {min:0,max:0}, railDrag = null, dragClickUntil = 0;
    if (typeof railRatio !== 'number' || !Number.isFinite(railRatio)) railRatio = null;
    else railRatio = Math.max(0, Math.min(1, railRatio));
    foldingRail.classList.add('chip-rail-collapsible');
    railLinks.forEach((link, index) => {
      link.id ||= 'quick-rail-link-' + index;
      link.dataset.railOriginalTabindex = link.getAttribute('tabindex') ?? '';
    });
    const clearRailTimers = () => { clearTimeout(openTimer); clearTimeout(closeTimer); };
    const paintRail = expanded => {
      railOpen = desktopRail.matches && expanded;
      foldingRail.classList.toggle('is-rail-open', railOpen);
      if (desktopRail.matches) {
        railHome.setAttribute('aria-expanded', String(railOpen));
        railHome.setAttribute('aria-controls', railLinks.map(link => link.id).join(' '));
      } else {
        railHome.removeAttribute('aria-expanded');
        railHome.removeAttribute('aria-controls');
      }
      railLinks.forEach(link => {
        const hidden = desktopRail.matches && !railOpen;
        link.inert = hidden;
        if (hidden) { link.setAttribute('aria-hidden', 'true'); link.tabIndex = -1; }
        else {
          link.removeAttribute('aria-hidden');
          if (link.dataset.railOriginalTabindex) link.setAttribute('tabindex', link.dataset.railOriginalTabindex);
          else link.removeAttribute('tabindex');
        }
      });
    };
    const layoutRail = () => {
      if (!desktopRail.matches) {
        clearRailTimers();
        foldingRail.style.removeProperty('top');
        paintRail(false);
        return;
      }
      const safeTop = 16, safeBottom = innerHeight - 16;
      const normalExtent = Math.max(0, railLinks.length - 2) * 62 + 2 * 74 + 56;
      const fit = Math.min(1, Math.max(.6, (safeBottom - safeTop - 56) / (normalExtent - 56)));
      const step = 62 * fit, gap = 74 * fit;
      const distance = index => index < upperCount
        ? -(gap + (upperCount - index - 1) * step)
        : gap + (index - upperCount) * step;
      railBounds = {min:safeTop - distance(0) + 28, max:safeBottom - distance(railLinks.length - 1) - 28};
      const center = railBounds.min + (railBounds.max - railBounds.min) * (railRatio ?? .5);
      foldingRail.style.top = center + 'px';
      foldingRail.classList.toggle('is-rail-condensed', step < 60);
      railLinks.forEach((link, index) => {
        link.style.setProperty('--rail-offset', distance(index) + 'px');
      });
      paintRail(railOpen);
    };
    foldingRail.addEventListener('pointerenter', event => {
      if (!desktopRail.matches || event.pointerType === 'touch' || railDrag?.active) return;
      suppressFocus = false;
      clearRailTimers();
      if (!railOpen) openTimer = setTimeout(() => paintRail(true), 220);
    });
    foldingRail.addEventListener('pointerleave', () => {
      if (railIntro || railDrag?.active) return;
      clearRailTimers();
      if (!foldingRail.contains(document.activeElement)) closeTimer = setTimeout(() => paintRail(false), 220);
    });
    foldingRail.addEventListener('focusin', () => {
      clearRailTimers();
      if (!suppressFocus) paintRail(true);
    });
    foldingRail.addEventListener('focusout', () => {
      setTimeout(() => { if (!railIntro && !foldingRail.contains(document.activeElement)) { suppressFocus = false; paintRail(false); } }, 0);
    });
    foldingRail.addEventListener('keydown', event => {
      if (event.target === railHome && desktopRail.matches && ['ArrowUp','ArrowDown'].includes(event.key)) {
        event.preventDefault();
        positionRail(parseFloat(foldingRail.style.top) + (event.key === 'ArrowUp' ? -1 : 1) * (event.shiftKey ? 40 : 10));
        return;
      }
      if (event.key !== 'Escape' || !desktopRail.matches) return;
      event.preventDefault(); finishRailIntro(); clearRailTimers(); suppressFocus = true;
      paintRail(false); railHome.focus({preventScroll:true});
    });
    foldingRail.addEventListener('click', event => {
      if (event.target.closest('a:not(.rail-logo)')) { finishRailIntro(); clearRailTimers(); paintRail(false); }
    });
    const positionRail = center => {
      const y = Math.max(railBounds.min, Math.min(railBounds.max, center));
      foldingRail.style.top = y + 'px';
      railRatio = railBounds.max > railBounds.min ? (y - railBounds.min) / (railBounds.max - railBounds.min) : .5;
      writeJson(railPositionKey, railRatio);
    };
    railHome.draggable = false;
    railHome.addEventListener('pointerdown', event => {
      if (!desktopRail.matches || event.button !== 0) return;
      railDrag = {id:event.pointerId,startY:event.clientY,center:parseFloat(foldingRail.style.top),active:false};
      railHome.setPointerCapture(event.pointerId);
    });
    railHome.addEventListener('pointermove', event => {
      if (!railDrag || event.pointerId !== railDrag.id) return;
      if (!railDrag.active && Math.abs(event.clientY - railDrag.startY) < 5) return;
      if (!railDrag.active) { railDrag.active = true; railHome.setPointerCapture(event.pointerId); }
      event.preventDefault(); clearRailTimers(); paintRail(false);
      positionRail(railDrag.center + event.clientY - railDrag.startY);
    });
    const stopRailDrag = event => {
      if (!railDrag || event.pointerId !== railDrag.id) return;
      if (railDrag.active) dragClickUntil = performance.now() + 300;
      if (railHome.hasPointerCapture(event.pointerId)) railHome.releasePointerCapture(event.pointerId);
      railDrag = null;
    };
    railHome.addEventListener('pointerup', stopRailDrag);
    railHome.addEventListener('pointercancel', stopRailDrag);
    // A wide touch screen has no hover: the first tap expands, the second follows Home.
    railHome.addEventListener('pointerdown', event => {
      if (desktopRail.matches && event.pointerType === 'touch' && !railOpen) {
        swallowTouchClick = true; event.preventDefault(); clearRailTimers(); paintRail(true);
      }
    });
    railHome.addEventListener('click', event => {
      if (swallowTouchClick || performance.now() < dragClickUntil) { swallowTouchClick = false; event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    document.addEventListener('pointerdown', event => {
      if (!foldingRail.contains(event.target)) { clearRailTimers(); paintRail(false); }
    });
    window.addEventListener('resize', layoutRail);
    window.addEventListener('load', layoutRail, {once:true});
    layoutRail();
    requestAnimationFrame(() => requestAnimationFrame(() => foldingRail.classList.add('is-rail-ready')));
  }

  applyStoreLanguage();
  const menu = document.querySelector(".menu-toggle");
  const nav = document.querySelector(".main-nav");
  const megaGroups = Array.from(nav?.querySelectorAll(".nav-mega-group") || []);
  const positionMegaMenu = group => {
    if (!window.matchMedia("(hover: hover) and (min-width: 901px)").matches) {
      group.style.removeProperty("--mega-menu-shift-x");
      return;
    }
    const panel = group.querySelector(".mega-menu");
    if (!panel) return;
    const groupBounds = group.getBoundingClientRect();
    const panelWidth = panel.getBoundingClientRect().width;
    const centeredLeft = groupBounds.left + groupBounds.width / 2 - panelWidth / 2;
    const minLeft = 12;
    const maxLeft = Math.max(minLeft, document.documentElement.clientWidth - panelWidth - 12);
    const fittedLeft = Math.max(minLeft, Math.min(centeredLeft, maxLeft));
    group.style.setProperty("--mega-menu-shift-x", `${fittedLeft - centeredLeft}px`);
  };
  const closeMegaGroup = group => {
    group.classList.remove("is-open");
    group.querySelector(".nav-mega-trigger")?.setAttribute("aria-expanded", "false");
    group.querySelector(".mega-menu")?.setAttribute("aria-hidden", "true");
  };
  const openMegaGroup = group => {
    megaGroups.forEach(other => { if (other !== group) closeMegaGroup(other); });
    positionMegaMenu(group);
    group.classList.add("is-open");
    group.querySelector(".nav-mega-trigger")?.setAttribute("aria-expanded", "true");
    group.querySelector(".mega-menu")?.setAttribute("aria-hidden", "false");
  };
  if (menu && nav) menu.addEventListener("click", () => {
    const open = menu.getAttribute("aria-expanded") === "true";
    menu.setAttribute("aria-expanded", String(!open));
    nav.classList.toggle("open", !open);
    if (open) megaGroups.forEach(closeMegaGroup);
  });
  megaGroups.forEach(group => {
    const trigger = group.querySelector(".nav-mega-trigger");
    group.addEventListener("pointerenter", () => {
      if (window.matchMedia("(hover: hover) and (min-width: 901px)").matches) openMegaGroup(group);
    });
    group.addEventListener("pointerleave", () => {
      if (window.matchMedia("(hover: hover) and (min-width: 901px)").matches && !group.contains(document.activeElement)) closeMegaGroup(group);
    });
    group.addEventListener("focusout", event => {
      if (!group.contains(event.relatedTarget)) closeMegaGroup(group);
    });
    trigger?.addEventListener("click", () => {
      if (window.matchMedia("(hover: hover) and (min-width: 901px)").matches) {
        openMegaGroup(group);
        return;
      }
      const isOpen = trigger.getAttribute("aria-expanded") === "true";
      if (isOpen) closeMegaGroup(group); else openMegaGroup(group);
    });
    group.querySelectorAll(".mega-menu a").forEach(link => link.addEventListener("click", () => {
      megaGroups.forEach(closeMegaGroup);
      if (window.innerWidth <= 900) {
        nav.classList.remove("open");
        menu?.setAttribute("aria-expanded", "false");
      }
    }));
    trigger?.addEventListener("keydown", event => {
      if (event.key !== "ArrowDown") return;
      event.preventDefault();
      openMegaGroup(group);
      group.querySelector(".mega-menu a")?.focus();
    });
  });
  document.addEventListener("pointerdown", event => {
    if (!nav?.contains(event.target)) megaGroups.forEach(closeMegaGroup);
  });
  document.addEventListener("keydown", event => {
    if (event.key !== "Escape") return;
    const opened = megaGroups.find(group => group.classList.contains("is-open"));
    if (!opened) return;
    const trigger = opened.querySelector(".nav-mega-trigger");
    closeMegaGroup(opened);
    trigger?.focus();
  });
  window.addEventListener("resize", () => {
    megaGroups.forEach(positionMegaMenu);
  });

  // Keep the featured link centered on the page, regardless of the side groups' widths.
  const featuredRow = siteHeader?.querySelector(".header-primary-row");
  const featuredAction = featuredRow?.querySelector(":scope > .header-cta-custom");
  const featuredBrand = featuredRow?.querySelector(".header-brand-search");
  const featuredActions = featuredRow?.querySelector(".header-actions");
  if (featuredRow && featuredAction && featuredBrand && featuredActions) {
    const fitFeaturedHeader = () => {
      // Flexible grid columns resize the side groups before switching to the mobile layout.
      featuredRow.classList.remove("header-featured-stacked");
      megaGroups.forEach(positionMegaMenu);
    };
    let featuredFrame = 0;
    const scheduleFeaturedHeader = () => {
      if (featuredFrame) return;
      featuredFrame = requestAnimationFrame(() => { featuredFrame = 0; fitFeaturedHeader(); });
    };
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(scheduleFeaturedHeader);
      [featuredRow, featuredBrand, featuredActions].forEach(element => observer.observe(element));
    }
    window.addEventListener("resize", scheduleFeaturedHeader);
    document.fonts?.ready.then(scheduleFeaturedHeader);
    fitFeaturedHeader();
  }

  // Fit closed menus as well so hidden panels cannot widen the document.
  megaGroups.forEach(positionMegaMenu);
  window.addEventListener("load", () => megaGroups.forEach(positionMegaMenu), { once: true });

  // Persist creator attribution from campaign links such as ?creator=handle.
  const creator = new URLSearchParams(location.search).get("creator");
  if (creator) writeJson(ATTRIBUTION_KEY, { creator: creator.slice(0, 80), capturedAt: new Date().toISOString() });

  // Optional advertising and analytics tags are loaded only after a consent choice.
  const getConsent = () => readJson(CONSENT_KEY, null);
  const injectScript = (src, id) => {
    if (id && document.querySelector(`[data-integration="${id}"]`)) return;
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    if (id) script.dataset.integration = id;
    document.head.appendChild(script);
  };
  const loadGoogle = () => {
    if (!CONFIG.ga4Id || !/^G-[A-Z0-9]+$/i.test(CONFIG.ga4Id)) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function(){ window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", CONFIG.ga4Id);
    injectScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(CONFIG.ga4Id)}`, "ga4");
    window.gtag("event", "page_view", { page_location: location.href, page_title: document.title });
  };
  const loadTikTok = () => {
    if (!CONFIG.tiktokPixelId) return;
    window.ttq = window.ttq || [];
    ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"].forEach(name => {
      window.ttq[name] = window.ttq[name] || function(){ window.ttq.push([name, ...arguments]); };
    });
    window.ttq.load = function(id){ injectScript(`https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${encodeURIComponent(id)}&lib=ttq`, "tiktok"); };
    window.ttq.load(CONFIG.tiktokPixelId);
    window.ttq.page();
  };
  const loadMeta = () => {
    if (!CONFIG.metaPixelId) return;
    window.fbq = window.fbq || function(){ window.fbq.queue.push(arguments); };
    window.fbq.queue = window.fbq.queue || [];
    window.fbq.loaded = true;
    injectScript("https://connect.facebook.net/en_US/fbevents.js", "meta");
    window.fbq("init", CONFIG.metaPixelId);
    window.fbq("track", "PageView");
  };
  const loadKlaviyo = () => {
    if (!CONFIG.klaviyoPublicKey) return;
    window._learnq = window._learnq || [];
    injectScript(`https://static.klaviyo.com/onsite/js/${encodeURIComponent(CONFIG.klaviyoPublicKey)}/klaviyo.js`, "klaviyo");
  };
  const applyConsent = () => {
    const consent = getConsent();
    if (!consent) return;
    if (consent.analytics) loadGoogle();
    if (consent.marketing) { loadTikTok(); loadMeta(); loadKlaviyo(); }
  };
  const track = (eventName, product, value) => {
    const consent = getConsent() || {};
    const item = { content_id: product?.id, content_ids: product?.id ? [product.id] : [], content_name: product?.name, content_type: "product", description: product?.name, quantity: product?.qty || 1, value: Number(value || product?.price || 0), currency: "USD" };
    if (consent.analytics && window.gtag) window.gtag("event", eventName, { currency: "USD", value: item.value, items: [{ item_id: item.content_id, item_name: item.content_name, quantity: item.quantity, price: Number(product?.price || 0) }] });
    if (consent.marketing && window.ttq) window.ttq.track(eventName === "add_to_cart" ? "AddToCart" : "ViewContent", item);
    if (consent.marketing && window.fbq) window.fbq("track", eventName === "add_to_cart" ? "AddToCart" : "ViewContent", item);
    if (consent.marketing && window._learnq && eventName === "add_to_cart") window._learnq.push(["track", "Added to Cart", item]);
  };

  // Consent banner and preference panel.
  const renderConsent = () => {
    if (getConsent()) return;
    document.body.classList.add("has-cookie-banner");
    const banner = document.createElement("aside");
    banner.className = "cookie-banner";
    banner.setAttribute("aria-label", "Cookie choices");
    banner.innerHTML = `<div><b>Your privacy choices</b><p>Essential storage keeps your cart working. Optional analytics and advertising tags stay off unless you choose them. See our <a href="privacy.html">Privacy Policy</a>.</p></div><div class="cookie-actions"><button type="button" data-consent="necessary">Reject optional</button><button type="button" data-consent="settings">Settings</button><button type="button" data-consent="all">Accept all</button></div>`;
    document.body.appendChild(banner);
    banner.addEventListener("click", event => {
      const action = event.target.closest("[data-consent]")?.dataset.consent;
      if (!action) return;
      if (action === "settings") return showConsentSettings();
      writeJson(CONSENT_KEY, { necessary: true, analytics: action === "all", marketing: action === "all", savedAt: new Date().toISOString() });
      banner.remove();
      document.body.classList.remove("has-cookie-banner");
      applyConsent();
    });
  };
  const showConsentSettings = () => {
    document.querySelector(".consent-modal")?.remove();
    const current = getConsent() || {};
    const modal = document.createElement("div");
    modal.className = "consent-modal";
    modal.innerHTML = `<section role="dialog" aria-modal="true" aria-labelledby="consent-title"><button class="consent-close" type="button" aria-label="Close">×</button><p class="eyebrow">PRIVACY CONTROLS</p><h2 id="consent-title">Choose your cookies.</h2><p>Essential storage is always on. Optional tags load only after you save your choice.</p><label class="consent-option"><span><b>Analytics</b><small>Google Analytics 4</small></span><input type="checkbox" data-choice="analytics" ${current.analytics ? "checked" : ""}></label><label class="consent-option"><span><b>Marketing</b><small>TikTok, Meta and Klaviyo</small></span><input type="checkbox" data-choice="marketing" ${current.marketing ? "checked" : ""}></label><button class="button button-dark" type="button" data-save-consent>Save choices</button></section>`;
    document.body.appendChild(modal);
    modal.querySelector(".consent-close").addEventListener("click", () => modal.remove());
    modal.addEventListener("click", event => { if (event.target === modal) modal.remove(); });
    modal.querySelector("[data-save-consent]").addEventListener("click", () => {
      writeJson(CONSENT_KEY, { necessary: true, analytics: modal.querySelector('[data-choice="analytics"]').checked, marketing: modal.querySelector('[data-choice="marketing"]').checked, savedAt: new Date().toISOString() });
      modal.remove();
      document.querySelector(".cookie-banner")?.remove();
      document.body.classList.remove("has-cookie-banner");
      applyConsent();
    });
  };
  document.querySelectorAll("[data-open-cookie-settings]").forEach(button => button.addEventListener("click", showConsentSettings));

  // Cart and creator-code storefront demo. Prices below must be replaced with approved prices.
  const getCart = () => readJson(CART_KEY, []);
  const setCart = items => { writeJson(CART_KEY, items); renderCart(); };
  const getDiscount = () => readJson("coolstar_discount_v1", null);
  const updateCartCount = () => document.querySelectorAll("[data-cart-count]").forEach(el => el.textContent = getCart().reduce((sum, item) => sum + Number(item.qty || 0), 0));
  document.querySelectorAll(".cart-link").forEach(link => {
    const control = document.createElement("div");
    control.className = "cart-control";
    link.parentNode.insertBefore(control, link);
    control.appendChild(link);
    const preview = document.createElement("section");
    preview.className = "cart-preview";
    preview.setAttribute("aria-label", "Cart preview");
    preview.innerHTML = `<div class="cart-preview-heading"><b>Your cart</b><span data-cart-preview-count>0 items</span></div><div class="cart-preview-items" data-cart-preview-items></div><div class="cart-preview-tools"><button type="button" data-preview-clear hidden>Clear cart</button><p class="cart-preview-status" data-cart-preview-status role="status" aria-live="polite"></p></div><div class="cart-preview-footer"><div class="cart-preview-summary"><div><span>Subtotal</span><b data-cart-preview-subtotal>$0.00</b></div><div><span>Discount</span><b data-cart-preview-discount>−$0.00</b></div><button type="button" class="cart-preview-benefit" data-preview-benefit>Sign in for a welcome gift</button></div><a class="cart-preview-button" href="cart.html">View cart <span>→</span></a></div>`;
    control.appendChild(preview);
    const alignPreview = () => {
      const panelWidth = preview.getBoundingClientRect().width;
      const bounds = control.getBoundingClientRect();
      control.classList.toggle("cart-preview-align-right", bounds.left + panelWidth > window.innerWidth - 12);
    };
    // Only the Cart button opens this panel. Crossing the gap must not be a new trigger.
    control.dataset.previewOpen = "false";
    let previewCloseTimer = 0, suppressCartFocus = false;
    const openPreview = () => {
      window.clearTimeout(previewCloseTimer);
      alignPreview(); control.dataset.previewOpen = "true";
    };
    const closePreview = () => { window.clearTimeout(previewCloseTimer); control.dataset.previewOpen = "false"; };
    const schedulePreviewClose = () => {
      window.clearTimeout(previewCloseTimer);
      previewCloseTimer = window.setTimeout(() => {
        const focused = document.activeElement;
        if (link.matches(":hover") || preview.matches(":hover") || (control.contains(focused) && focused.matches(":focus-visible"))) return;
        closePreview();
      }, 180);
    };
    link.addEventListener("pointerenter", event => { if (event.pointerType === "mouse") openPreview(); });
    preview.addEventListener("pointerenter", event => { if (event.pointerType === "mouse") openPreview(); });
    control.addEventListener("pointerleave", schedulePreviewClose);
    control.addEventListener("focusin", () => { if (!suppressCartFocus) openPreview(); });
    control.addEventListener("focusout", event => { if (!previewCartBusy && !control.contains(event.relatedTarget)) closePreview(); });
    document.addEventListener("pointerdown", event => { if (!control.contains(event.target)) closePreview(); });
    document.addEventListener("keydown", event => {
      if (event.key === "Escape" && control.dataset.previewOpen === "true") {
        closePreview(); suppressCartFocus = true; link.focus(); suppressCartFocus = false;
      }
    });
    window.addEventListener("resize", alignPreview);
    alignPreview();
  });
  let previewCartBusy = false;
  const cartCopy = (en, zh) => activeLanguage.startsWith("zh") ? zh : en;
  const renderCartPreviews = cart => {
    const subtotal = cart.reduce((sum, item) => sum + Number(item.price || 0) * Number(item.qty || 0), 0);
    const discount = getDiscount();
    const discountValue = discount ? subtotal * Number(discount.percent || 0) / 100 : 0;
    document.querySelectorAll(".cart-preview").forEach(preview => {
      const quantity = cart.reduce((sum, item) => sum + Number(item.qty || 0), 0);
      const count = preview.querySelector("[data-cart-preview-count]");
      const subtotalNode = preview.querySelector("[data-cart-preview-subtotal]");
      const discountNode = preview.querySelector("[data-cart-preview-discount]");
      const itemsNode = preview.querySelector("[data-cart-preview-items]");
      preview.querySelector('.cart-preview-heading>b').textContent = cartCopy('Your cart','购物车');
      const clear = preview.querySelector('[data-preview-clear]');
      clear.hidden = !cart.length; clear.disabled = previewCartBusy; clear.textContent = cartCopy('Clear cart','清空购物车');
      preview.setAttribute('aria-busy',String(previewCartBusy));
      if (count) count.textContent = cartCopy(`${quantity} ${quantity === 1 ? "item" : "items"}`,`${quantity} 件商品`);
      const nativeTotals = window.CoolstarShopifyTheme ? window.CoolstarNativeCart?.totals : null;
      if (subtotalNode) subtotalNode.textContent = nativeTotals?.subtotal || money(subtotal);
      if (discountNode) discountNode.textContent = `−${nativeTotals?.discount || money(discountValue)}`;
      if (!itemsNode) return;
      if (!cart.length) {
        itemsNode.innerHTML = `<p class="cart-preview-empty">Your cart is empty. <a href="products.html">Browse the collection →</a></p>`;
        return;
      }
      itemsNode.innerHTML = cart.map(item => {
        const image = item.image || "https://www.coolstarpoker.com/cdn/shop/files/coolstar-poker-banner-04.jpg?v=1782814088&width=260&quality=70";
        const qty = Number(item.qty || 0);
        return `<article class="cart-preview-item" data-preview-id="${escapeHtml(item.id)}"><img src="${escapeHtml(image)}" alt=""><div class="cart-preview-item-copy"><b>${escapeHtml(item.name)}</b><small>${escapeHtml(item.variant || "Retail item")} · ${escapeHtml(item.unitPriceLabel || money(item.price))}</small><div class="cart-preview-qty"><button type="button" data-preview-change="-1" aria-label="${cartCopy('Decrease quantity','减少数量')}" ${previewCartBusy || qty<=1 ? 'disabled' : ''}>−</button><output>${qty}</output><button type="button" data-preview-change="1" aria-label="${cartCopy('Increase quantity','增加数量')}" ${previewCartBusy ? 'disabled' : ''}>+</button></div></div><div class="cart-preview-item-end"><strong>${escapeHtml(item.lineTotal || money(Number(item.price || 0) * qty))}</strong><button type="button" class="cart-preview-remove" data-preview-remove ${previewCartBusy ? 'disabled' : ''}>${cartCopy('Remove','删除')}</button></div></article>`;
      }).join("");
    });
  };
  document.addEventListener('click', async event => {
    const button=event.target.closest('[data-preview-change],[data-preview-remove],[data-preview-clear]');
    if(!button || previewCartBusy)return;
    event.preventDefault();
    const preview=button.closest('.cart-preview'),row=button.closest('[data-preview-id]'),id=row?.dataset.previewId;
    const action=button.hasAttribute('data-preview-clear')?'clear':button.hasAttribute('data-preview-remove')?'remove':'change';
    const change=Number(button.dataset.previewChange||0),cart=getCart(),item=cart.find(entry=>String(entry.id)===id);
    if(action!=='clear'&&!item)return;
    preview.querySelector('[data-cart-preview-status]').textContent='';
    previewCartBusy=true;renderCartPreviews(cart);
    try{
      if(window.CoolstarShopifyTheme){
        const adapter=window.CoolstarNativeCart;
        if(!adapter)throw new Error(cartCopy('The cart is loading. Please try again.','购物车正在加载，请稍后重试。'));
        if(action==='clear')await adapter.clear();
        else await adapter.changeLine(id,action==='remove'?0:Math.max(1,Number(item.qty)+change));
        if(document.body.dataset.page==='cart')location.reload();
      }else{
        if(action==='clear')setCart([]);
        else if(action==='remove')setCart(cart.filter(entry=>String(entry.id)!==id));
        else {item.qty=Math.max(1,Number(item.qty)+change);setCart(cart);}
      }
    }catch(error){preview.querySelector('[data-cart-preview-status]').textContent=error.message;}
    finally{
      previewCartBusy=false;renderCartPreviews(getCart());
      const next=[...preview.querySelectorAll('[data-preview-id]')].find(el=>el.dataset.previewId===id);
      const focus=action==='change'?next?.querySelector(`[data-preview-change="${change}"]:not(:disabled)`):null;
      const control=preview.closest('.cart-control');
      if(control?.dataset.previewOpen==='true')(focus||control.querySelector('.cart-link'))?.focus({preventScroll:true});
    }
  });
  const renderCart = () => {
    updateCartCount();
    const cart = getCart();
    renderCartPreviews(cart);
    const root = document.querySelector("#cart-items");
    if (!root || window.CoolstarShopifyTheme) return;
    if (!cart.length) {
      root.innerHTML = `<p class="cart-empty">Your cart is empty. <a href="products.html">Browse the poker range →</a></p>`;
    } else {
      root.innerHTML = cart.map(item => `<article class="cart-item" data-cart-id="${escapeHtml(item.id)}"><img src="${escapeHtml(item.image || "https://www.coolstarpoker.com/cdn/shop/files/coolstar-poker-banner-04.jpg?v=1782814088&width=260&quality=70")}" alt=""><div><b>${escapeHtml(item.name)}</b><small>${escapeHtml(item.variant || "Retail item")} · ${money(item.price)} each</small><div class="cart-qty"><button type="button" data-cart-change="-1" aria-label="Decrease quantity">−</button><span>${Number(item.qty)}</span><button type="button" data-cart-change="1" aria-label="Increase quantity">+</button><button type="button" data-cart-remove>Remove</button></div></div><strong>${money(Number(item.price) * Number(item.qty))}</strong></article>`).join("");
    }
    const subtotal = cart.reduce((sum, item) => sum + Number(item.price) * Number(item.qty), 0);
    const discount = getDiscount();
    const discountValue = discount ? subtotal * Number(discount.percent || 0) / 100 : 0;
    const setText = (id, value) => { const node = document.getElementById(id); if (node) node.textContent = value; };
    setText("cart-subtotal", money(subtotal));
    setText("cart-discount", `−${money(discountValue)}`);
    setText("cart-total", money(subtotal - discountValue));
    const codeStatus = document.getElementById("discount-status");
    if (codeStatus && discount) codeStatus.textContent = `${discount.code} applied${discount.creator ? ` · creator ${discount.creator}` : ""}.`;
  };
  const setCurrencyMenuValue = code => {
    const menu = document.querySelector(`[data-locale-menu][data-preference="${CURRENCY_KEY}"]`);
    const options = Array.from(menu?.querySelectorAll("[data-locale-value]") || []);
    options.forEach(option => option.setAttribute("aria-selected", String(option.dataset.localeValue === code)));
    const current = menu?.querySelector("[data-locale-current]");
    const label = options.find(option => option.dataset.localeValue === code)?.textContent;
    if (current && label) current.textContent = label;
  };
  const refreshCurrencyDisplays = () => {
    document.querySelectorAll("[data-usd-price]").forEach(node => {
      const baseAmount = Number(node.dataset.usdPrice);
      if (Number.isFinite(baseAmount)) node.textContent = money(baseAmount);
    });
    document.querySelectorAll("[data-currency-note]").forEach(node => {
      node.textContent = displayCurrency === "USD" ? "USD · sample price, replace before launch" : `Approximate ${displayCurrency} display · sample price is set in USD`;
    });
    document.querySelectorAll("[data-set-price-note]").forEach(node => {
      const priceNode = node.parentElement?.querySelector("[data-set-price]");
      node.textContent = priceNode?.dataset.usdPrice
        ? (displayCurrency === "USD" ? "USD · sample offer" : `Approx. ${displayCurrency} · based on USD sample offer`)
        : "USD · tailored quote";
    });
    document.querySelectorAll("[data-set-final-cta]").forEach(node => {
      const button = node.closest("[data-set-cta]");
      const amount = Number(button?.dataset.price || 0);
      if (amount > 0) node.textContent = `Buy now — ${money(amount)} sample price`;
    });
    const totalLabel = document.querySelector(".summary-total span");
    if (totalLabel) totalLabel.textContent = `Total (${displayCurrency})`;
    const conversionNote = document.querySelector("[data-cart-conversion-note]");
    if (conversionNote) conversionNote.hidden = displayCurrency === "USD";
    renderCart();
  };
  let currencyRequestId = 0;
  const selectStoreCurrency = async (requestedCode, announce = true) => {
    if (!currencyCodes.includes(requestedCode)) return;
    const requestId = ++currencyRequestId;
    if (requestedCode === "USD") {
      displayCurrency = "USD";
      localStorage.setItem(CURRENCY_KEY, "USD");
      setCurrencyMenuValue("USD");
      refreshCurrencyDisplays();
      if (announce) showLocaleFeedback(t("currency"));
      return;
    }
    const previousCurrency = displayCurrency;
    const hasCachedRate = Number.isFinite(Number(fxRates[requestedCode])) && Number(fxRates[requestedCode]) > 0;
    if (hasCachedRate) {
      displayCurrency = requestedCode;
      setCurrencyMenuValue(requestedCode);
      refreshCurrencyDisplays();
    }
    const cachedRateFetchedAt = Number(fxRatesFetchedAt[requestedCode] || 0);
    if (hasCachedRate && cachedRateFetchedAt && Date.now() - cachedRateFetchedAt < 20 * 60 * 60 * 1000) {
      localStorage.setItem(CURRENCY_KEY, requestedCode);
      if (announce) showLocaleFeedback(t("currency"));
      return;
    }
    try {
      const quotes = [...new Set([requestedCode, "EUR"])].join(",");
      const response = await fetch(`https://api.frankfurter.dev/v2/rates?base=USD&quotes=${encodeURIComponent(quotes)}`, { headers: { Accept: "application/json" } });
      if (!response.ok) throw new Error("Rate service unavailable");
      const rows = await response.json();
      const row = Array.isArray(rows) ? rows.find(rate => rate.quote === requestedCode && rate.base === "USD") : null;
      const eurRow = Array.isArray(rows) ? rows.find(rate => rate.quote === "EUR" && rate.base === "USD") : null;
      let rate = Number(row?.rate);
      if ((!Number.isFinite(rate) || rate <= 0) && Number.isFinite(fixedUsdRates[requestedCode])) rate = fixedUsdRates[requestedCode];
      if ((!Number.isFinite(rate) || rate <= 0) && Number.isFinite(fixedEurRates[requestedCode])) {
        const usdToEur = Number(eurRow?.rate || fxRates.EUR);
        if (Number.isFinite(usdToEur) && usdToEur > 0) rate = fixedEurRates[requestedCode] * usdToEur;
      }
      if (!Number.isFinite(rate) || rate <= 0) throw new Error("Rate not available");
      if (requestId !== currencyRequestId) return;
      fxRates = { ...fxRates, [requestedCode]: rate, USD: 1 };
      displayCurrency = requestedCode;
      setCurrencyMenuValue(requestedCode);
      fxRatesFetchedAt[requestedCode] = Date.now();
      fxRateDates[requestedCode] = row?.date || eurRow?.date || (fixedUsdRates[requestedCode] || fixedEurRates[requestedCode] ? "fixed peg" : "");
      writeJson(RATE_CACHE_KEY, { rates: fxRates, fetchedAt: fxRatesFetchedAt, dates: fxRateDates });
      localStorage.setItem(CURRENCY_KEY, requestedCode);
      refreshCurrencyDisplays();
      if (announce) showLocaleFeedback(t("currency"));
    } catch {
      if (requestId !== currencyRequestId) return;
      if (fxRates[requestedCode]) {
        displayCurrency = requestedCode;
        setCurrencyMenuValue(requestedCode);
        localStorage.setItem(CURRENCY_KEY, requestedCode);
        refreshCurrencyDisplays();
        const cachedDate = fxRateDates[requestedCode] ? ` (${fxRateDates[requestedCode]})` : "";
        showLocaleFeedback(`${requestedCode} · using cached reference rate${cachedDate}. Checkout remains in USD.`);
      } else {
        const fallbackCurrency = previousCurrency !== requestedCode && fxRates[previousCurrency] ? previousCurrency : "USD";
        displayCurrency = fallbackCurrency;
        localStorage.setItem(CURRENCY_KEY, fallbackCurrency);
        setCurrencyMenuValue(fallbackCurrency);
        refreshCurrencyDisplays();
        showLocaleFeedback(`Latest reference rate unavailable for ${requestedCode}. Prices remain in ${fallbackCurrency}.`);
      }
    }
  };
  if (displayCurrency !== "USD") selectStoreCurrency(displayCurrency, false);
  window.addEventListener("pageshow", () => {
    const savedLanguage = localStorage.getItem(LANGUAGE_KEY);
    if (languageKeys.includes(savedLanguage) && savedLanguage !== activeLanguage) {
      activeLanguage = savedLanguage;
      applyStoreLanguage();
      window.setPageLocale?.(activeLanguage);
      refreshCurrencyDisplays();
    }
    const savedCurrency = localStorage.getItem(CURRENCY_KEY);
    if (currencyCodes.includes(savedCurrency) && savedCurrency !== displayCurrency) selectStoreCurrency(savedCurrency, false);
  });
  const landingSetCatalog = {
    "300": {
      count: "300", id: "cs-300-set", productName: "300-Piece Poker Chip Set",
      pageTitle: "300-Piece Poker Chip Set | Coolstar Poker",
      kicker: "THE EASY HOSTING SET", heading: "Three hundred chips.", subheading: "Ready for game night.",
      description: "A compact chip count for casual games, smaller tables and easy storage. Choose a material and ask us to confirm the set contents.",
      price: 89, priceLabel: "USD · sample offer", cta: "Buy the 300-piece set",
      note: "Sample offer — confirm price, chip material and set contents before launch.",
      assurance: "✓ Compact set option　 ✓ Material choices available　 ✓ USD quote",
      cardTitle: "300-piece poker chip set", benefitTitle: "A compact chip set",
      benefitCopy: "A streamlined option for smaller games. Ask us to confirm exact contents and materials.",
      finalHeading: "A table-ready set, your way.", finalCopy: "Get your 300-piece poker set. Sample price and payment methods require final store setup.", finalCta: "Buy now — $89 sample price"
    },
    "500": {
      count: "500", id: "cs-500-set", productName: "500-Piece Poker Chip Set",
      pageTitle: "500-Piece Poker Chip Set | Coolstar Poker",
      kicker: "THE TABLE-READY FAVORITE", heading: "Five hundred chips.", subheading: "All in for game night.",
      description: "A complete poker set for game nights, regular play and clubs. Shop direct, or ask about custom branding for your store or venue.",
      price: 129, priceLabel: "USD · sample offer", cta: "Buy the 500-piece set",
      note: "Sample offer — confirm price, chip material and set contents before launch.",
      assurance: "✓ Easy online shopping　 ✓ Custom options available　 ✓ USD pricing",
      cardTitle: "500-piece poker chip set", benefitTitle: "A complete 500-piece set",
      benefitCopy: "Review the exact chip breakdown, material and included accessories before ordering.",
      finalHeading: "Ready to play?", finalCopy: "Get your 500-piece poker set. Sample price and payment methods require final store setup.", finalCta: "Buy now — $129 sample price"
    },
    "750": {
      count: "750", id: "cs-750-set", productName: "750-Piece Poker Chip Set",
      pageTitle: "750-Piece Poker Chip Set | Coolstar Poker",
      kicker: "MORE ROOM AT THE TABLE", heading: "Seven hundred fifty chips.", subheading: "Keep the game moving.",
      description: "A larger stack for longer sessions and larger groups. Choose a material and ask us to confirm the set contents for your table.",
      price: 179, priceLabel: "USD · sample offer", cta: "Buy the 750-piece set",
      note: "Sample offer — confirm price, chip material and set contents before launch.",
      assurance: "✓ Larger set option　 ✓ Material choices available　 ✓ USD quote",
      cardTitle: "750-piece poker chip set", benefitTitle: "More chips for the table",
      benefitCopy: "A higher piece count for longer sessions. Ask us to confirm exact contents and materials.",
      finalHeading: "Keep the game going.", finalCopy: "Get your 750-piece poker set. Sample price and payment methods require final store setup.", finalCta: "Buy now — $179 sample price"
    },
    "1000": {
      count: "1,000", id: "cs-1000-set", productName: "1,000-Piece Poker Chip Set",
      pageTitle: "1,000-Piece Poker Chip Set | Coolstar Poker",
      kicker: "THE FULL TABLE STACK", heading: "One thousand chips.", subheading: "Go all in on game night.",
      description: "A full-size chip selection for lively tables, frequent play and larger groups. Ask us to confirm the materials and exact set breakdown.",
      price: 229, priceLabel: "USD · sample offer", cta: "Buy the 1,000-piece set",
      note: "Sample offer — confirm price, chip material and set contents before launch.",
      assurance: "✓ Full table option　 ✓ Material choices available　 ✓ USD quote",
      cardTitle: "1,000-piece poker chip set", benefitTitle: "A full table stack",
      benefitCopy: "A high-count option for larger games. Ask us to confirm exact contents and materials.",
      finalHeading: "Set up your next big game.", finalCopy: "Get your 1,000-piece poker set. Sample price and payment methods require final store setup.", finalCta: "Buy now — $229 sample price"
    }
  };
  const landingTabs = [...document.querySelectorAll("[data-set-option]")];
  if (landingTabs.length) {
    const landingCopy = document.querySelector(".landing-copy, .feature-copy");
    const setText = (selector, value) => document.querySelectorAll(selector).forEach(node => { node.textContent = value; });
    let setSwapTimer;
    const selectLandingSet = count => {
      const set = landingSetCatalog[count];
      if (!set) return;
      landingCopy?.classList.add("is-changing");
      window.clearTimeout(setSwapTimer);
      setSwapTimer = window.setTimeout(() => {
        setText("[data-set-kicker]", set.kicker);
        setText("[data-set-heading]", set.heading);
        setText("[data-set-subheading]", set.subheading);
        setText("[data-set-description]", set.description);
        document.querySelectorAll("[data-set-price]").forEach(node => {
          if (set.price === null) { delete node.dataset.usdPrice; node.textContent = set.priceLabel; }
          else { node.dataset.usdPrice = String(set.price); node.textContent = money(set.price); }
        });
        setText("[data-set-price-note]", set.price === null ? "USD · tailored quote" : displayCurrency === "USD" ? set.priceLabel : `Approx. ${displayCurrency} · based on USD sample offer`);
        setText("[data-set-note]", set.note);
        setText("[data-set-assurance]", set.assurance);
        setText("[data-set-badge]", set.count);
        setText("[data-set-card-title]", set.cardTitle);
        setText("[data-set-benefit-title]", set.benefitTitle);
        setText("[data-set-benefit-copy]", set.benefitCopy);
        setText("[data-set-final-heading]", set.finalHeading);
        setText("[data-set-final-copy]", set.finalCopy);
        setText("[data-set-final-cta]", set.price === null ? set.finalCta : `Buy now — ${money(set.price)} sample price`);
        document.querySelectorAll("[data-set-cta]").forEach(button => {
          button.dataset.buyNow = set.id;
          button.dataset.name = set.productName;
          button.dataset.price = set.price === null ? "0" : String(set.price);
          const label = button.querySelector("[data-set-cta-label]") || button.querySelector("span:first-child");
          if (label) label.textContent = button.querySelector("[data-set-final-cta]") ? set.finalCta : set.cta;
          if (set.price === null) button.dataset.quoteSet = set.productName;
          else delete button.dataset.quoteSet;
          button.classList.toggle("is-quote", set.price === null);
        });
        const image = document.querySelector("[data-set-image]");
        if (image) image.alt = set.productName + " product display";
        const productLink = document.querySelector("[data-set-product-link]");
        if (productLink) {
          if (set.price === null) {
            const quoteUrl = new URL("wholesale.html", location.href);
            quoteUrl.searchParams.set("set", set.productName);
            productLink.href = quoteUrl.href;
          } else productLink.href = "500-chip-set.html";
        }
        landingTabs.forEach(tab => tab.setAttribute("aria-pressed", tab.dataset.setOption === count ? "true" : "false"));
        const announcement = document.getElementById("landing-set-announcement");
        if (announcement) announcement.textContent = set.count + "-piece set selected. " + (set.price === null ? "Price on request." : set.priceLabel + ".");
        if (document.body.dataset.page === "landing") {
          document.title = set.pageTitle;
          const description = document.querySelector('meta[name="description"]');
          if (description) description.content = set.description;
        }
        landingCopy?.classList.remove("is-changing");
      }, 120);
    };
    landingTabs.forEach(tab => tab.addEventListener("click", () => selectLandingSet(tab.dataset.setOption)));
    const requestedCount = new URLSearchParams(location.search).get("count");
    if (requestedCount && landingSetCatalog[requestedCount]) selectLandingSet(requestedCount);
  }
  const requestedSet = new URLSearchParams(location.search).get("set");
  const wholesaleSetMessage = document.querySelector('#wholesale-form textarea[name="message"], #wholesale-form textarea[name="contact[body]"]');
  if (requestedSet && wholesaleSetMessage && !wholesaleSetMessage.value) {
    wholesaleSetMessage.value = `I'm interested in the ${requestedSet}. Please send current USD pricing and confirm the set contents.`;
    const wholesaleCategory = document.querySelector('#wholesale-form select[name="products"], #wholesale-form select[name="contact[Products]"]');
    if (wholesaleCategory) wholesaleCategory.value = "Poker chips";
  }
  const addToCart = button => {
    if (button.dataset.quoteSet) {
      const quoteUrl = new URL("wholesale.html", location.href);
      quoteUrl.searchParams.set("set", button.dataset.quoteSet);
      quoteUrl.hash = "wholesale-form";
      location.href = quoteUrl.href;
      return;
    }
    const id = button.dataset.addToCart || button.dataset.buyNow;
    const name = button.dataset.name || "Poker product";
    const price = Number(button.dataset.price || 0);
    const quantity = Math.max(1, Number(document.getElementById("retail-quantity")?.value || 1));
    const variant = document.getElementById("chip-material")?.value || "Standard set";
    const cart = getCart();
    const existing = cart.find(item => item.id === id && item.variant === variant);
    if (existing) existing.qty += quantity;
    else cart.push({ id, name, price, qty: quantity, variant, image: "https://www.coolstarpoker.com/cdn/shop/files/coolstar-poker-banner-04.jpg?v=1782814088&width=500&quality=75" });
    setCart(cart);
    track("add_to_cart", { id, name, price, qty: quantity }, price * quantity);
    if (button.hasAttribute("data-buy-now")) location.href = "cart.html";
    else { button.classList.add("added"); button.innerHTML = "Added to cart <span>✓</span>"; }
  };
  document.querySelectorAll("[data-add-to-cart], [data-buy-now]").forEach(button => button.addEventListener("click", () => addToCart(button)));
  document.querySelectorAll("[data-qty]").forEach(button => button.addEventListener("click", () => {
    const input = document.getElementById("retail-quantity");
    if (input) input.value = Math.max(1, Math.min(99, Number(input.value || 1) + Number(button.dataset.qty)));
  }));
  const cartRoot = document.querySelector("#cart-items");
  if (cartRoot) cartRoot.addEventListener("click", event => {
    const itemNode = event.target.closest("[data-cart-id]");
    if (!itemNode || window.CoolstarShopifyTheme) return;
    const cart = getCart();
    const item = cart.find(entry => entry.id === itemNode.dataset.cartId);
    if (event.target.closest("[data-cart-remove]")) setCart(cart.filter(entry => entry.id !== itemNode.dataset.cartId));
    else if (event.target.closest("[data-cart-change]") && item) {
      item.qty += Number(event.target.closest("[data-cart-change]").dataset.cartChange);
      setCart(item.qty < 1 ? cart.filter(entry => entry.id !== item.id) : cart);
    }
  });
  renderCart();
  window.addEventListener("shopify:cart:changed", renderCart);
  const applyCode = document.getElementById("apply-code");
  if (applyCode) applyCode.addEventListener("click", () => {
    const input = document.getElementById("discount-code");
    const code = (input?.value || "").trim().toUpperCase();
    const status = document.getElementById("discount-status");
    const found = CONFIG.creatorCodes[code];
    if (!found) { if (status) status.textContent = "Code not configured in this demo. Add the approved code and discount in site.js."; return; }
    const attribution = readJson(ATTRIBUTION_KEY, {});
    writeJson("coolstar_discount_v1", { code, percent: Number(found.percent), creator: found.creator || attribution.creator || "" });
    renderCart();
  });
  document.querySelectorAll("[data-checkout]").forEach(button => button.addEventListener("click", () => {
    const status = document.getElementById("checkout-status");
    if (status) status.textContent = "Checkout is not connected. Add approved Stripe and PayPal merchant credentials and complete platform setup before taking payment.";
  }));

  // Quote list for business inquiries.
  const QUOTE_KEY_LIST = () => readJson(QUOTE_KEY, []);
  document.querySelectorAll("[data-add-quote]").forEach(button => button.addEventListener("click", () => {
    const product = button.dataset.addQuote;
    const list = QUOTE_KEY_LIST();
    if (!list.includes(product)) list.push(product);
    writeJson(QUOTE_KEY, list);
    button.innerHTML = 'Added to quote list <span>✓</span>';
    const status = document.querySelector("#quote-list-status");
    if (status) status.textContent = `${product} added to your quote list.`;
  }));
  const quoteSelect = document.querySelector("#product-select");
  const quoteItems = QUOTE_KEY_LIST();
  if (quoteSelect && quoteItems.length) {
    const multi = [...quoteSelect.options].find(option => option.value === "Multiple categories");
    quoteSelect.value = quoteItems.length === 1 ? quoteItems[0] : multi?.value || "";
    const summary = document.createElement("div");
    summary.className = "quote-summary";
    summary.innerHTML = `<b>Your quote list</b><span>${quoteItems.map(escapeHtml).join(" · ")}</span>`;
    quoteSelect.closest("label").insertAdjacentElement("afterend", summary);
  }

  const submitInquiry = (form, status) => {
    if (!form) return;
    form.addEventListener("submit", event => {
      event.preventDefault();
      if (!CONFIG.contactEmail.trim()) { status.textContent = "Inquiry delivery is not enabled. Add your company email in assets/js/site.js or connect a form service."; return; }
      const data = new FormData(form);
      const lines = [...data.entries()].map(([key, value]) => `${key}: ${value || "Not provided"}`);
      lines.push("Currency: USD", `Creator attribution: ${readJson(ATTRIBUTION_KEY, {})?.creator || "None"}`);
      const subject = encodeURIComponent(`Coolstar Poker inquiry — ${data.get("company") || data.get("name") || "Website"}`);
      location.href = `mailto:${encodeURIComponent(CONFIG.contactEmail)}?subject=${subject}&body=${encodeURIComponent(lines.join("\n"))}`;
      status.textContent = "Your email app is opening with the inquiry details.";
    });
  };
  if (!window.CoolstarShopifyTheme) {
    submitInquiry(document.querySelector("#quote-form"), document.querySelector("#form-status"));
    submitInquiry(document.querySelector("#wholesale-form"), document.querySelector("#wholesale-status"));
  }

  if (!document.querySelector(".whatsapp-float")) {
    const contactWidget = document.createElement("div");
    contactWidget.className = "contact-float";
    contactWidget.innerHTML = `
      <a class="whatsapp-float is-placeholder" href="contact.html#whatsapp" data-whatsapp-link aria-label="Contact us on WhatsApp" aria-controls="contact-float-panel" aria-expanded="false" title="Drag vertically to reposition" draggable="false">
        <span class="contact-trigger-copy" aria-hidden="true"><span>◉</span><b>WhatsApp</b><span class="contact-float-caret">⌄</span></span>
        <span class="contact-trigger-logo" aria-hidden="true"><img src="${escapeHtml(window.CoolstarShopifyTheme?.assets?.whatsappLogo || 'assets/images/whatsapp-logo.svg')}" alt="" width="32" height="32"></span>
      </a>
      <div class="contact-float-panel" id="contact-float-panel" aria-label="Contact details">
        <div class="contact-float-heading"><small>WE’RE HERE TO HELP</small><b>Talk to our team</b><p>Product, order and wholesale questions are welcome.</p></div>
        <a class="contact-float-row" href="contact.html#whatsapp" data-whatsapp-link><span>WhatsApp</span><b data-whatsapp-label>[Add WhatsApp business number]</b></a>
        <div class="contact-float-row"><span>Business email</span><b data-contact-email>[Add your company email]</b></div>
        <a class="contact-float-quote" href="contact.html"><b>Request a quote</b><span aria-hidden="true">↗</span></a>
      </div>`;
    document.body.appendChild(contactWidget);

    const emailDetail = contactWidget.querySelector("[data-contact-email]");
    if (emailDetail && CONFIG.contactEmail.trim()) {
      const emailLink = document.createElement("a");
      emailLink.href = `mailto:${CONFIG.contactEmail.trim()}`;
      emailLink.textContent = CONFIG.contactEmail.trim();
      emailDetail.replaceChildren(emailLink);
    }
  }

  document.querySelectorAll("[data-whatsapp-link]").forEach(link => {
    const number = CONFIG.whatsappNumber.replace(/\D/g, "");
    if (number) {
      link.href = `https://wa.me/${number}`;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      const label = link.querySelector("[data-whatsapp-label]");
      if (label) label.textContent = CONFIG.whatsappNumber.trim() || `+${number}`;
      link.classList.remove("is-placeholder");
    } else {
      link.classList.add("is-placeholder");
      link.title = "Add your WhatsApp Business number in assets/js/site.js before launch.";
    }
  });
  const contactFloat = document.querySelector(".contact-float");
  const contactTrigger = contactFloat?.querySelector(".whatsapp-float");
  if (contactFloat && contactTrigger) {
    const contactPanel = contactFloat.querySelector(".contact-float-panel");
    const backToTop = document.createElement("button");
    backToTop.type = "button";
    backToTop.className = "back-to-top-float";
    backToTop.setAttribute("aria-label", "Back to top");
    backToTop.title = "Back to top";
    backToTop.innerHTML = '<span aria-hidden="true">↑</span>';
    document.body.appendChild(backToTop);
    const positionBackToTop = () => {
      const triggerRect = contactTrigger.getBoundingClientRect();
      const buttonRect = backToTop.getBoundingClientRect();
      const top = Math.max(8, Math.min(window.innerHeight - buttonRect.height - 8, triggerRect.top + (triggerRect.height - buttonRect.height) / 2));
      backToTop.style.top = `${top}px`;
      backToTop.style.right = `${Math.max(8, window.innerWidth - triggerRect.left + 12)}px`;
    };
    const syncBackToTop = () => {
      const visible = window.scrollY > 320 && contactTrigger.getClientRects().length > 0;
      backToTop.classList.toggle("is-visible", visible);
      backToTop.setAttribute("aria-hidden", String(!visible));
      backToTop.tabIndex = visible ? 0 : -1;
      if (visible) positionBackToTop();
    };
    backToTop.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
    });
    window.addEventListener("scroll", syncBackToTop, { passive: true });
    // Re-measure each frame of the width transition so the arrow follows the left edge.
    if (window.ResizeObserver) new ResizeObserver(syncBackToTop).observe(contactTrigger);
    syncBackToTop();
    const positionKey = "coolstar_contact_float_top";
    const dockContactToBottom = ["custom", "designs", "chip-customizer", "set-customizer", "supplies-customizer"].includes(document.body.dataset.page);
    const dockContact = () => {
      contactFloat.style.top = "auto";
      contactFloat.style.right = "20px";
      contactFloat.style.bottom = "16px";
      contactFloat.style.transform = "none";
      positionBackToTop();
    };
    let dragState = null;
    let suppressNextClick = false;
    let contactPanelCloseTimer = 0;
    let contactPanelOpenTimer = 0;
    const cancelContactPanelOpen = () => window.clearTimeout(contactPanelOpenTimer);
    const compactKey = "coolstar_contact_interacted_v1";
    let contactHasOpened = false, suppressContactFocus = false;
    try { contactHasOpened = sessionStorage.getItem(compactKey) === "1"; } catch { /* Page-only interaction state. */ }
    contactFloat.classList.toggle("is-compact", contactHasOpened);
    const setContactFloatTop = (requestedTop, persist = true) => {
      const maxTop = Math.max(8, window.innerHeight - contactTrigger.offsetHeight - 8);
      const top = Math.max(8, Math.min(maxTop, requestedTop));
      contactFloat.style.top = `${top}px`;
      contactFloat.style.bottom = "auto";
      contactFloat.style.transform = "none";
      contactFloat.dataset.userPositioned = "true";
      positionBackToTop();
      if (persist) localStorage.setItem(positionKey, String(top / window.innerHeight));
      return top;
    };
    const updateContactPanelPosition = () => {
      if (!contactPanel) return;
      const triggerRect = contactTrigger.getBoundingClientRect();
      const panelHeight = contactPanel.scrollHeight;
      const availableAbove = Math.max(0, triggerRect.top - 20);
      const availableBelow = Math.max(0, window.innerHeight - triggerRect.bottom - 20);
      const opensUp = availableBelow < panelHeight && availableAbove > availableBelow;
      const available = opensUp ? availableAbove : availableBelow;
      contactFloat.classList.toggle("panel-opens-up", opensUp);
      contactFloat.style.setProperty("--contact-panel-max-height", `${Math.max(120, Math.min(window.innerHeight * .7, available))}px`);
    };
    const savedTop = Number(localStorage.getItem(positionKey));
    if (Number.isFinite(savedTop) && savedTop > 0) setContactFloatTop(savedTop * window.innerHeight, false);
    else if (dockContactToBottom) dockContact();
    window.addEventListener("resize", () => {
      if (contactFloat.dataset.userPositioned === "true") {
        const storedTop = Number(localStorage.getItem(positionKey));
        if (Number.isFinite(storedTop) && storedTop > 0) setContactFloatTop(storedTop * window.innerHeight, false);
      } else if (dockContactToBottom) dockContact();
      updateContactPanelPosition();
      positionBackToTop();
    });

    contactTrigger.addEventListener("pointerdown", event => {
      if (!event.isPrimary || event.button !== 0) return;
      cancelContactPanelOpen();
      const rect = contactFloat.getBoundingClientRect();
      dragState = { pointerId: event.pointerId, startY: event.clientY, startTop: rect.top, moved: false };
      contactTrigger.setPointerCapture(event.pointerId);
    });
    contactTrigger.addEventListener("pointermove", event => {
      if (!dragState || event.pointerId !== dragState.pointerId) return;
      const deltaY = event.clientY - dragState.startY;
      if (!dragState.moved && Math.abs(deltaY) < 4) return;
      dragState.moved = true;
      contactFloat.classList.add("is-dragging");
      setContactFloatTop(dragState.startTop + deltaY, false);
      updateContactPanelPosition();
    });
    const finishContactDrag = event => {
      if (!dragState || event.pointerId !== dragState.pointerId) return;
      if (dragState.moved) {
        setContactFloatTop(contactFloat.getBoundingClientRect().top);
        suppressNextClick = true;
        window.setTimeout(() => { suppressNextClick = false; }, 0);
      }
      dragState = null;
      contactFloat.classList.remove("is-dragging");
    };
    contactTrigger.addEventListener("pointerup", finishContactDrag);
    contactTrigger.addEventListener("pointercancel", finishContactDrag);
    contactTrigger.addEventListener("click", event => {
      if (!suppressNextClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressNextClick = false;
    });
    contactTrigger.addEventListener("keydown", event => {
      if (event.key !== "ArrowUp" && event.key !== "ArrowDown") return;
      event.preventDefault();
      const rect = contactFloat.getBoundingClientRect();
      setContactFloatTop(rect.top + (event.key === "ArrowUp" ? -24 : 24));
      updateContactPanelPosition();
    });
    const syncContactExpanded = expanded => contactTrigger.setAttribute("aria-expanded", String(expanded));
    const openContactPanel = () => {
      cancelContactPanelOpen();
      window.clearTimeout(contactPanelCloseTimer);
      contactHasOpened = true;
      try { sessionStorage.setItem(compactKey, "1"); } catch { /* Page-only interaction state. */ }
      contactFloat.classList.remove("is-compact");
      contactFloat.classList.add("is-panel-open");
      syncContactExpanded(true);
      updateContactPanelPosition();
    };
    const closeContactPanel = () => {
      cancelContactPanelOpen();
      contactFloat.classList.remove("is-panel-open");
      // Keep the arrow still under the pointer while it is being clicked.
      if (contactHasOpened && !backToTop.matches(":hover")) contactFloat.classList.add("is-compact");
      syncContactExpanded(false);
    };
    const scheduleContactPanelClose = (delay = 180) => {
      window.clearTimeout(contactPanelCloseTimer);
      contactPanelCloseTimer = window.setTimeout(() => {
        const focused = document.activeElement;
        if (contactTrigger.matches(":hover") || contactPanel?.matches(":hover") || backToTop.matches(":hover") || (contactFloat.contains(focused) && focused.matches(":focus-visible"))) return;
        closeContactPanel();
      }, delay);
    };
    contactTrigger.addEventListener("pointerenter", event => {
      if (event.pointerType === "touch" || !window.matchMedia("(hover: hover)").matches) return;
      cancelContactPanelOpen();
      window.clearTimeout(contactPanelCloseTimer);
      if (contactFloat.classList.contains("is-panel-open")) return;
      contactPanelOpenTimer = window.setTimeout(() => {
        if (contactTrigger.matches(":hover") && !dragState && !contactFloat.classList.contains("is-order-controls-visible")) openContactPanel();
      }, 220);
    });
    contactTrigger.addEventListener("pointerleave", () => { cancelContactPanelOpen(); scheduleContactPanelClose(); });
    contactPanel?.addEventListener("pointerenter", () => window.clearTimeout(contactPanelCloseTimer));
    contactPanel?.addEventListener("pointerleave", () => scheduleContactPanelClose());
    let contactWidthFrozenForArrow = false;
    backToTop.addEventListener("pointerenter", event => {
      window.clearTimeout(contactPanelCloseTimer);
      if (event.pointerType !== "touch") {
        // Stop an in-flight expansion too, so the arrow stays under the pointer.
        contactTrigger.style.width = `${contactTrigger.getBoundingClientRect().width}px`;
        contactTrigger.style.transitionProperty = "background-color,color,border-color,box-shadow";
        contactWidthFrozenForArrow = true;
      }
      closeContactPanel();
      positionBackToTop();
    });
    backToTop.addEventListener("pointerleave", () => {
      if (contactWidthFrozenForArrow) {
        if (contactHasOpened && !contactFloat.classList.contains("is-panel-open")) contactFloat.classList.add("is-compact");
        contactTrigger.style.removeProperty("width");
        contactTrigger.style.removeProperty("transition-property");
        contactWidthFrozenForArrow = false;
      }
      scheduleContactPanelClose();
    });
    contactFloat.addEventListener("focusin", event => {
      window.clearTimeout(contactPanelCloseTimer);
      if (!suppressContactFocus && event.target.matches(":focus-visible")) openContactPanel();
    });
    contactFloat.addEventListener("focusout", event => {
      if (!contactFloat.contains(event.relatedTarget)) scheduleContactPanelClose(350);
    });
    document.addEventListener("pointerdown", event => {
      if (!contactFloat.contains(event.target)) cancelContactPanelOpen();
      if (!contactFloat.contains(event.target) && !backToTop.contains(event.target) && contactFloat.classList.contains("is-panel-open")) closeContactPanel();
    });
    document.addEventListener("keydown", event => {
      if (event.key === "Escape" && contactFloat.classList.contains("is-panel-open")) {
        closeContactPanel(); suppressContactFocus = true; contactTrigger.focus(); suppressContactFocus = false;
      }
    });
    if (document.body.dataset.page === "chip-customizer") {
      const orderPanel = document.querySelector(".chip-order-panel");
      if (orderPanel && "IntersectionObserver" in window) {
        const orderPanelObserver = new IntersectionObserver(([entry]) => {
          const overlapsOrderControls = entry.isIntersecting;
          contactFloat.classList.toggle("is-order-controls-visible", overlapsOrderControls);
          if (overlapsOrderControls) closeContactPanel();
        }, { threshold: 0.01 });
        orderPanelObserver.observe(orderPanel);
      }
    }
  }

  applyConsent();
  if (["product", "landing"].includes(document.body.dataset.page)) track("view_item", { id: "cs-500-set", name: "500-Piece Poker Chip Set", price: 129, qty: 1 }, 129);
  renderConsent();

  if (!window.CoolstarShopifyTheme) {
    const accountScript = document.createElement("script");
    accountScript.src = "assets/js/account.js?v=20261017-account-nav-cleanup";
    accountScript.async = false;
    document.body.appendChild(accountScript);
  }
})();
